import { TranslationObject } from "../types";

const ENGLISH_TRANSLATIONS: TranslationObject = {
  CLASSES: {
    id: "CLASSES",
    defaultMessage: "Classes",
  },
  PARTICIPATION: {
    id: "PARTICIPATION",
    defaultMessage: "Participation",
  },
  ATTENDANCE: {
    id: "ATTENDANCE",
    defaultMessage: "Attendance",
  },
  PRESENT: {
    id: "PRESENT",
    defaultMessage: "present",
  },
  ABSENT: {
    id: "ABSENT",
    defaultMessage: "absent",
  },
  SOON: {
    id: "SOON",
    defaultMessage: "Soon",
  },
  CLASS_ROOMS: {
    id: "CLASS_ROOMS",
    defaultMessage: "Classrooms",
  },
  CLASS_ROOM: {
    id: "CLASS_ROOM",
    defaultMessage: "Classroom",
  },
  LANGUAGES: {
    id: "LANGUAGES",
    defaultMessage: "Languages",
  },
  ACCOUNT_SETTINGS: {
    id: "ACCOUNT_SETTINGS",
    defaultMessage: "Account settings",
  },
  LOGOUT: {
    id: "LOGOUT",
    defaultMessage: "Log out",
  },
  LOGOUT_CONFIRM_TITLE: {
    id: "LOGOUT_CONFIRM_TITLE",
    defaultMessage: "Log out?",
  },
  LOGOUT_CONFIRM_BODY: {
    id: "LOGOUT_CONFIRM_BODY",
    defaultMessage: "You will need to sign in again to access your classes.",
  },
  ADD: {
    id: "ADD",
    defaultMessage: "ADD",
  },
  EDIT: {
    id: "EDIT",
    defaultMessage: "Edit",
  },
  REMOVE: {
    id: "REMOVE",
    defaultMessage: "Remove",
  },
  OBSERVATION: {
    id: "OBSERVATION",
    defaultMessage: "Observation",
  },
  NO_DATA: {
    id: "NO_DATA",
    defaultMessage: "No data",
  },
  STUDENTS: {
    id: "STUDENTS",
    defaultMessage: "Students",
  },
  SUBJECT: {
    id: "SUBJECT",
    defaultMessage: "Subject",
  },
  CREATED_AT: {
    id: "CREATED_AT",
    defaultMessage: "Created at",
  },
  STUDENT: {
    id: "STUDENT",
    defaultMessage: "Student",
  },
  DATE: {
    id: "DATE",
    defaultMessage: "Date",
  },
  HOME_WORK: {
    id: "HOME_WORK",
    defaultMessage: "Home work",
  },
  RESET: {
    id: "RESET",
    defaultMessage: "Reset",
  },
  REMOVE_QUALIFICATION: {
    id: "REMOVE_QUALIFICATION",
    defaultMessage: "Remove qualification",
  },
  REMOVE_STUDENT: {
    id: "REMOVE_STUDENT",
    defaultMessage: "Remove student",
  },
  QUALIFIED: {
    id: "QUALIFIED",
    defaultMessage: "Qualified",
  },
  NOT_QUALIFIED: {
    id: "NOT_QUALIFIED",
    defaultMessage: "Not qualified",
  },
  OPTIONS: {
    id: "OPTIONS",
    defaultMessage: "Options",
  },
  LESSON_DATE: {
    id: "LESSON_DATE",
    defaultMessage: "Date",
  },
  DATE_RANGE: {
    id: "DATE_RANGE",
    defaultMessage: "Date range",
  },
  LAST_WEEK: {
    id: "LAST_WEEK",
    defaultMessage: "Last week",
  },
  LAST_MONTH: {
    id: "LAST_MONTH",
    defaultMessage: "Last month",
  },
  LAST_3_MONTHS: {
    id: "LAST_3_MONTHS",
    defaultMessage: "Last 3 months",
  },
  LAST_6_MONTHS: {
    id: "LAST_6_MONTHS",
    defaultMessage: "Last 6 months",
  },
  LAST_YEAR: {
    id: "LAST_YEAR",
    defaultMessage: "Last year",
  },
  CUSTOM_DATE: {
    id: "CUSTOM_DATE",
    defaultMessage: "Custom",
  },
  NO_PARTICIPATION: {
    id: "NO_PARTICIPATION",
    defaultMessage: "No participation",
  },
  USELESS: {
    id: "USELESS",
    defaultMessage: "Poor",
  },
  POOR: {
    id: "POOR",
    defaultMessage: "Little participation",
  },
  OK: {
    id: "OK",
    defaultMessage: "Constant participation",
  },
  GOOD: {
    id: "GOOD",
    defaultMessage: "Committed participation",
  },
  EXCELENT: {
    id: "EXCELENT",
    defaultMessage: "Excellent participation",
  },
  TOTAL_AVERAGE: {
    id: "TOTAL_AVERAGE",
    defaultMessage: "Total Average",
  },
  INDIVIDUAL_EVALUATIONS: {
    id: "INDIVIDUAL_EVALUATIONS",
    defaultMessage: "Individual evalutaions",
  },
  MONTLY_REVIEW: {
    id: "MONTLY_REVIEW",
    defaultMessage: "Monthly review",
  },
  EVALUATION: {
    id: "EVALUATION",
    defaultMessage: "Evaluation",
  },
  STARS: {
    id: "STARS",
    defaultMessage: "Stars",
  },
  STAR: {
    id: "STAR",
    defaultMessage: "One star",
  },
  NO_STARTS: {
    id: "NO_STARTS",
    defaultMessage: "No stars",
  },
  JANUAR: {
    id: "JANUAR",
    defaultMessage: "January",
  },
  FEBRUARY: {
    id: "FEBRUARY",
    defaultMessage: "February",
  },
  MARCH: {
    id: "MARCH",
    defaultMessage: "March",
  },
  APRIL: {
    id: "APRIL",
    defaultMessage: "April",
  },
  MAY: {
    id: "MAY",
    defaultMessage: "May",
  },
  JUNE: {
    id: "JUNE",
    defaultMessage: "June",
  },
  JULY: {
    id: "JULY",
    defaultMessage: "July",
  },
  AUGUST: {
    id: "AUGUST",
    defaultMessage: "August",
  },
  SEPTEMBER: {
    id: "SEPTEMBER",
    defaultMessage: "September",
  },
  OCTOBER: {
    id: "OCTOBER",
    defaultMessage: "October",
  },
  NOVEMBER: {
    id: "NOVEMBER",
    defaultMessage: "November",
  },
  DECEMBER: {
    id: "DECEMBER",
    defaultMessage: "December",
  },
  MONTH: {
    id: "MONTH",
    defaultMessage: "Month",
  },
  YEAR: {
    id: "YEAR",
    defaultMessage: "Year",
  },
  CREATE_CLASSROOM: {
    id: "CREATE_CLASSROOM",
    defaultMessage: "Create classroom",
  },
  UPDATE_STUDENT: {
    id: "UPDATE_STUDENT",
    defaultMessage: "Edit Student",
  },
  EDIT_CLASSROOM: {
    id: "EDIT_CLASSROOM",
    defaultMessage: "Edit classroom",
  },
  CREATE_CLASSROOM_NAME: {
    id: "CREATE_CLASSROOM_NAME",
    defaultMessage: "Classroom name",
  },
  CREATE_CLASSROOM_SUBJECT: {
    id: "CREATE_CLASSROOM_SUBJECT",
    defaultMessage: "Classroom subject",
  },
  CREATE_CLASSROOM_NAME_ERROR_MSG: {
    id: "CREATE_CLASSROOM_NAME_ERROR_MSG",
    defaultMessage: "Please enter a valid classroom name",
  },
  CREATE_CLASSROOM_SUBJECT_ERROR_MSG: {
    id: "CREATE_CLASSROOM_SUBJECT_ERROR_MSG",
    defaultMessage: "Please enter a valid subject",
  },
  CREATE_CLASSROOM_SCHOOLYEAR_ERROR_MSG: {
    id: "CREATE_CLASSROOM_SCHOOLYEAR_ERROR_MSG",
    defaultMessage: "Please enter a valid school year",
  },
  CREATE: {
    id: "CREATE",
    defaultMessage: "Create",
  },
  CANCEL: {
    id: "CANCEL",
    defaultMessage: "Cancel",
  },
  CREATE_STUDENT: {
    id: "CREATE_STUDENT",
    defaultMessage: "Create Student",
  },
  CREATE_STUDENT_HINT_TEXT: {
    id: "CREATE_STUDENT_HINT_TEXT",
    defaultMessage: `The student will be created and attached to the classroom`,
    composedMessage: function (text: string) {
      return (
        <div>
          <div className="mb-2">
            The student will be created and attached to the classroom:{" "}
            <span className="secondary-color">{text}</span>.
          </div>
          <div>
            Student names according to the pattern first name - last name.
          </div>
        </div>
      );
    },
  },
  CREATE_STUDENT_SORTING_EXPLANATION_TEXT: {
    id: "CREATE_STUDENT_SORTING_EXPLANATION_TEXT",
    defaultMessage:
      "You decide whether you enter the first and last names of your students or limit yourself to the first names or, for example, the first name and the initial of the last name. In the course list, students are sorted alphabetically by their last name or initials, if available. If not, we sort alphabetically by first name. To ensure that the order corresponds to your course list, please make sure to enter the names according to a consistent pattern.",
    composedMessage: function () {
      return (
        <div>
          <div className="mb-2">
            You decide whether you enter the first and last names of your
            students or limit yourself to the first names or, for example, the
            first name and the initial of the last name.
          </div>
          <div className="mb-2">
            In the course list, students are sorted alphabetically by their last
            name or initials, if available. If not, we sort alphabetically by
            first name.
          </div>
          <div>
            To ensure that the order corresponds to your course list, please
            make sure to enter the names according to a consistent pattern.
          </div>
        </div>
      );
    },
  },
  FOR_INSTANCE_SHORCUT: {
    id: "FOR_INSTANCE_SHORCUT",
    defaultMessage: "E.g",
  },
  CREATE_STUDENT_NAME_ERROR_MSG: {
    id: "CREATE_STUDENT_NAME_ERROR_MSG",
    defaultMessage: "Please enter a valid student name",
  },
  STUDENT_NAME: {
    id: "STUDENT_NAME",
    defaultMessage: "Student name",
  },
  SAVE: {
    id: "SAVE",
    defaultMessage: "Save",
  },
  OBSERVATIONS: {
    id: "OBSERVATIONS",
    defaultMessage: "Observations",
  },
  OBSERVATIONS_TEXT: {
    id: "OBSERVATIONS",
    defaultMessage: "Text",
  },
  OBSERVATIONS_TEXT_HINT: {
    id: "OBSERVATIONS_TEXT_HINT",
    defaultMessage: "Here there is space for all your notes.",
  },
  NO_CLASSROOMS: {
    id: "NO_CLASSROOMS",
    defaultMessage: "There is no classrooms yet.",
  },
  ADD_FIRST_CLASROOM: {
    id: "ADD_FIRST_CLASROOM",
    defaultMessage: "Start creating your first classroom now.",
  },
  ADD_FIRST_CLASROOM_BUTTON: {
    id: "ADD_FIRST_CLASROOM_BUTTON",
    defaultMessage: "Add the first classroom.",
  },
  NO_STUDENTS: {
    id: "NO_STUDENTS",
    defaultMessage: "There is no Students yet.",
  },
  ADD_FIRST_STUDENT: {
    id: "ADD_FIRST_STUDENT",
    defaultMessage: "Start adding your first student.",
  },
  ADD_FIRST_STUDENT_BUTTON: {
    id: "ADD_FIRST_STUDENT_BUTTON",
    defaultMessage: "Add the first Student.",
  },
  NO_STUDENT_DATA: {
    id: "NO_STUDENT_DATA",
    defaultMessage: "There is no data for this student.",
  },
  START_CREATING_QUALIFICATION: {
    id: "START_CREATING_QUALIFICATION",
    defaultMessage:
      "Start creating qualifications for this student to see average and time line data.",
    composedHtmlMessage: (
      <div>
        Start creating qualifications for this student to see{" "}
        <b className="secondary-color">average</b> and{" "}
        <b className="secondary-color">time line data.</b>
      </div>
    ),
  },
  ARE_YOU_SURE_REMOVE_QUALIFICATION: {
    id: "ARE_YOU_SURE_REMOVE_QUALIFICATION",
    defaultMessage: "Are you sure you want to remove this review?",
  },
  ARE_YOU_SURE_REMOVE_ITEM: {
    id: "ARE_YOU_SURE_REMOVE_ITEM",
    defaultMessage: "Are you sure you want to remove this Item?.",
  },
  ARE_YOU_SURE_REMOVE_CLASSROM: {
    id: "ARE_YOU_SURE_REMOVE_CLASSROM",
    defaultMessage: "Are you sure you want to remove this clasroom?",
  },
  ARE_YOU_SURE_REMOVE_STUDENT: {
    id: "ARE_YOU_SURE_REMOVE_STUDENT",
    defaultMessage: "Are you sure you want to remove this Student?",
  },
  REMOVE_CLASSROOM: {
    id: "REMOVE_CLASSROOM",
    defaultMessage: "Remove classroom",
  },
  YOU_WILL_LOSE_DATA: {
    id: "YOU_WILL_LOSE_DATA",
    defaultMessage:
      "You will lose all the students qualifications and their data over time.",
  },
  YOU_WILL_LOSE_STUDENT: {
    id: "YOU_WILL_LOSE_STUDENT",
    defaultMessage:
      "You will lose all the student qualifications and the data over time.",
  },
  THIS_CANT_UNDONE: {
    id: "THIS_CANT_UNDONE",
    defaultMessage: "This action cannot be undone.",
  },
  TO_CONFIRM_DELETION: {
    id: "TO_CONFIRM_DELETION",
    defaultMessage: "To confirm deletion type the name in the input field.",
    composedMessage: function (text: string) {
      return (
        <div>
          To confirm deletion type <b className="secondary-color">{text}</b> in
          the input field.
        </div>
      );
    },
  },
  TO_CONFIRM_DELETION_CLASSROOM: {
    id: "TO_CONFIRM_DELETION_CLASSROOM",
    defaultMessage: "To confirm deletion type the name in the input field.",
    composedMessage: function (text: string) {
      return (
        <div>
          To confirm deletion type{" "}
          <b className="secondary-color">
            <i>{text}</i>
          </b>{" "}
          in the input field.
        </div>
      );
    },
  },
  DELETE_VERIFICATION_INPUT_MSG: {
    id: "DELETE_VERIFICATION_INPUT_MSG",
    defaultMessage: "Please enter a valid verification text.",
  },
  VERIFICATION_TEXT: {
    id: "VERIFICATION_TEXT",
    defaultMessage: "Verification Text",
  },
  REMOVE_STUDENT_QUALIFICATION: {
    id: "REMOVE_STUDENT_QUALIFICATION",
    defaultMessage: "Remove qualification",
  },
  DATA_LOST_FOR_STUDENT: {
    id: "DATA_LOST_FOR_STUDENT",
    defaultMessage:
      "The input for this Student will be deleted, also the remarks.",
    composedMessage: function (text: string) {
      return (
        <div>
          The input for{" "}
          <b className="secondary-color">
            <i>{text}</i>
          </b>{" "}
          will be deleted, also the remarks.
        </div>
      );
    },
  },
  PARTICIPATION_INFO: {
    id: "PARTICIPATION_INFO",
    defaultMessage:
      "To unmark the participation, click again in the current participation star",
  },
  EMAIL: {
    id: "EMAIL",
    defaultMessage: "E-Mail",
  },
  PASSWORD: {
    id: "PASSWORD",
    defaultMessage: "Password",
  },
  LOGIN: {
    id: "LOGIN",
    defaultMessage: "Login",
  },
  SIGNUP: {
    id: "SIGNUP",
    defaultMessage: "Sign Up",
  },
  EMAIL_LOGIN_ERROR_TEXT: {
    id: "EMAIL_LOGIN_ERROR_TEXT",
    defaultMessage: "Please enter a email",
  },
  PASSWORD_LOGIN_ERROR_TEXT: {
    id: "PASSWORD_LOGIN_ERROR_TEXT",
    defaultMessage: "Please enter a valid password",
  },
  NAME_LOGIN_ERROR_TEXT: {
    id: "NAME_LOGIN_ERROR_TEXT",
    defaultMessage: "Please enter a name",
  },
  LOGIN_SUCCESS_TEXT: {
    id: "LOGIN_SUCCESS_TEXT",
    defaultMessage: "Login successfull",
  },
  LOGIN_ERROR_PASSWORD_TEXT: {
    id: "LOGIN_ERROR_PASSWORD_TEXT",
    defaultMessage: "Incorrect password",
  },
  NO_USER_EMAIL: {
    id: "NO_USER_EMAIL",
    defaultMessage: "No user with that email",
  },
  TEXT: {
    id: "TEXT",
    defaultMessage: "text",
  },
  BACK_TO_LOGIN: {
    id: "BACK_TO_LOGIN",
    defaultMessage: "Back to login",
  },
  YOUR_NAME: {
    id: "YOUR_NAME",
    defaultMessage: "Your name",
  },
  SIGNIP_SUCCESS_TEXT: {
    id: "SIGNIP_SUCCESS_TEXT",
    defaultMessage: "Sign in successfull",
  },
  TITLE_SIGNUP: {
    id: "TITLE_SIGNUP",
    defaultMessage: "Sign Up",
  },
  CLASSTROOMS_TITLE: {
    id: "CLASSTROOMS_TITLE",
    defaultMessage: "School Year",
  },
  CREATE_CLASSROOM_SUCCESS: {
    id: "CREATE_CLASSROOM_SUCCESS",
    defaultMessage: "Classroom created successfully",
  },
  CREATE_CLASSROOM_ERROR: {
    id: "CREATE_CLASSROOM_ERROR",
    defaultMessage: "Error creating the classroom, please try again.",
  },
  UPDATE_CLASSROOM_SUCCESS: {
    id: "UPDATE_CLASSROOM_SUCCESS",
    defaultMessage: "Classroom updated successfully",
  },
  UPDATE_CLASSROOM_ERROR: {
    id: "UPDATE_CLASSROOM_ERROR",
    defaultMessage: "Error updating the classroom, please try again.",
  },
  DELETE_CLASSROOM_SUCCESS: {
    id: "DELETE_CLASSROOM_SUCCESS",
    defaultMessage: "Classroom deleted successfully",
  },
  DELETE_CLASSROOM_ERROR: {
    id: "DELETE_CLASSROOM_ERROR",
    defaultMessage: "Error deleting the classroom, please try again.",
  },
  UPDATE_CLASSROOM_OBSERVATION_SUCCESS: {
    id: "UPDATE_CLASSROOM_OBSERVATION_SUCCESS",
    defaultMessage: "Observation updated successfully",
  },
  UPDATE_CLASSROOM_OBSERVATION_ERROR: {
    id: "UPDATE_CLASSROOM_OBSERVATION_ERROR",
    defaultMessage:
      "Error updating the classroom observation, please try again.",
  },
  CREATE_STUDENT_SUCCESS: {
    id: "CREATE_STUDENT_SUCCESS",
    defaultMessage: "Student created successfully",
  },
  CREATE_STUDENTS_SUCCESS: {
    id: "CREATE_STUDENTS_SUCCESS",
    defaultMessage: "Students created successfully",
  },
  CREATE_STUDENT_ERROR: {
    id: "CREATE_STUDENT_ERROR",
    defaultMessage: "Error creating the student, please try again.",
  },
  UPDATE_STUDENT_SUCCESS: {
    id: "UPDATE_STUDENT_SUCCESS",
    defaultMessage: "Student updated successfully",
  },
  UPDATE_STUDENT_ERROR: {
    id: "UPDATE_STUDENT_ERROR",
    defaultMessage: "Error updating the student, please try again.",
  },
  DELETE_STUDENT_SUCCESS: {
    id: "DELETE_STUDENT_SUCCESS",
    defaultMessage: "Student deleted successfully",
  },
  DELETE_STUDENT_ERROR: {
    id: "DELETE_STUDENT_ERROR",
    defaultMessage: "Error deleting the student, please try again.",
  },
  REMOVE_QUALIFICATION_SUCCESS: {
    id: "REMOVE_QUALIFICATION_SUCCESS",
    defaultMessage: "Student qualification deleted successfully",
  },
  REMOVE_QUALIFICATION_ERROR: {
    id: "REMOVE_QUALIFICATION_ERROR",
    defaultMessage:
      "Error deleting the student qualification, please try again.",
  },
  UPDATE_STUDENT_OBSERVATION_SUCCESS: {
    id: "UPDATE_STUDENT_OBSERVATION_SUCCESS",
    defaultMessage: "Observation updated successfully",
  },
  UPDATE_STUDENT_OBSERVATION_ERROR: {
    id: "UPDATE_STUDENT_OBSERVATION_ERROR",
    defaultMessage:
      "Error updating the studfent observation, please try again.",
  },
  UPDATE_BULK_SWITCH_SUCCESS: {
    id: "UPDATE_BULK_SWITCH_SUCCESS",
    defaultMessage: "All Home works updated successfully",
  },
  UPDATE_BULK_SWITCH_ERROR: {
    id: "UPDATE_BULK_SWITCH_ERROR",
    defaultMessage: "Error updating the student Home works, please try again.",
  },
  UPDATE_STUDENT_QUALIFICATION_ERROR: {
    id: "UPDATE_STUDENT_QUALIFICATION_ERROR",
    defaultMessage: "Error updating the qualification, please try again.",
  },
  UPDATE_STUDENT_ATTENDANCE_ERROR: {
    id: "UPDATE_STUDENT_ATTENDANCE_ERROR",
    defaultMessage: "Error updating the attendance, please try again.",
  },
  UPDATE_STUDENT_HOMEWORK_ERROR: {
    id: "UPDATE_STUDENT_HOMEWORK_ERROR",
    defaultMessage: "Error updating the home work, please try again.",
  },
  UPDATE_LANGUAGE_SUCCESS: {
    id: "UPDATE_LANGUAGE_SUCCESS",
    defaultMessage: "Language updated successfully",
  },
  UPDATE_LANGUAGE_ERROR: {
    id: "UPDATE_LANGUAGE_ERROR",
    defaultMessage: "Error updating the home work, please try again.",
  },
  OPTIONAL: {
    id: "OPTIONAL",
    defaultMessage: "Optional",
  },
  OPTIONAL_CLASSROOM_STUDENTS_TEXT: {
    id: "OPTIONAL_CLASSROOM_STUDENTS_TEXT",
    defaultMessage:
      "Choose a Classroom to add automatically all the students of this class to your new Classroom.",
  },
  HOMEWORK_BULK_SELECTION_TITLE: {
    id: "HOMEWORK_BULK_SELECTION_TITLE",
    defaultMessage: "Home work bulk selection",
  },
  HOMEWORK_BULK_SELECTION_BODY_TEXT: {
    id: "HOMEWORK_BULK_SELECTION_BODY_TEXT",
    defaultMessage: "Home work is going to be updated for all students",
  },
  CONFIRM: {
    id: "CONFIRM",
    defaultMessage: "Confirm",
  },
  CLASSROOM_OBSERVATION_TITLE: {
    id: "CLASSROOM_OBSERVATION_TITLE",
    defaultMessage: "Remarks for the Classroom",
  },
  CLASSROOM_OBSERVATION_BODY: {
    id: "CLASSROOM_OBSERVATION_BODY",
    defaultMessage:
      "Here there is place for all your notes. For example, write down what you are awarding stars for, which students are in the E or G course or which disadvantage compensation needs to be taken into account",
  },
  STUDENT_OBSERVATION_TITLE: {
    id: "STUDENT_OBSERVATION_TITLE",
    defaultMessage: "Remarks for the student",
  },
  STUDENT_OBSERVATION_BODY: {
    id: "STUDENT_OBSERVATION_BODY",
    defaultMessage:
      "Here there is place for all your notes. For example, write down agreements you made with the student, grades you reported back or feedback you gave him or her",
  },
  DAY_CLASS_OBSERVATION_TITLE: {
    id: "DAY_CLASS_OBSERVATION_TITLE",
    defaultMessage: "Remarks for the student on this lesson",
  },
  DAY_CLASS_OBSERVATION_BODY: {
    id: "DAY_CLASS_OBSERVATION_BODY",
    defaultMessage:
      "Here there is place for all your notes. The comment will appear next to the student's rating for that day. For example, note whether working time was used, lessons were disrupted or whether the team worked well",
  },
  FORGOT_PASSWORD: {
    id: "FORGOT_PASSWORD",
    defaultMessage: "Forgot Password",
  },
  RESET_YOUR_PASSWORD: {
    id: "RESET_YOUR_PASSWORD",
    defaultMessage: "Reset your Password",
  },
  CONTINUE: {
    id: "CONTINUE",
    defaultMessage: "Continue",
  },
  FORGOT_PASS_TEXT_INFO: {
    id: "FORGOT_PASS_TEXT_INFO",
    defaultMessage:
      "Enter your user account's email address and we will send you a password reset link.",
  },
  TRY_AGAIN: {
    id: "TRY_AGAIN",
    defaultMessage: "An error occurred, please try again.",
  },
  EMAIL_SENT: {
    id: "EMAIL_SENT",
    defaultMessage: "Reset password email sent",
  },
  EMAIL_SENT_SUCCESS: {
    id: "EMAIL_SENT_SUCCESS",
    defaultMessage: "Email sent successfully.",
  },
  CHECK_INBOX: {
    id: "CHECK_INBOX",
    defaultMessage: "Please check your email inbox.",
  },
  PASS_NOT_MATCH: {
    id: "PASS_NOT_MATCH",
    defaultMessage: "Passwords do not match.",
  },
  PASS_UPDATED: {
    id: "PASS_UPDATED",
    defaultMessage: "Password updated successfully.",
  },
  PASS_UPDATED_EXPIRED: {
    id: "PASS_UPDATED_EXPIRED",
    defaultMessage: "Reset password link expired, please try again.",
  },
  EMAIL_NOT_EXIST: {
    id: "EMAIL_NOT_EXIST",
    defaultMessage: "User email does not exist.",
  },
  SKIP: {
    id: "SKIP",
    defaultMessage: "Skip",
  },
  BACK: {
    id: "BACK",
    defaultMessage: "Back",
  },
  INSTALL_APP_STEP_0: {
    id: "INSTALL_APP_STEP_0",
    defaultMessage:
      "Keep TutoriFy★ always at your fingertips! Add our app to your device's home screen for quick and direct access.",
  },
  INSTALL_APP_STEP_1_SAFARI: {
    id: "INSTALL_APP_STEP_1_SAFARI",
    defaultMessage:
      "Safari browser tap the share icon in the bottom navigation bar:",
  },
  INSTALL_APP_STEP_1_FIREFOX: {
    id: "INSTALL_APP_STEP_1_FIREFOX",
    defaultMessage:
      "Firefox browser tap the menu button (three vertical dots) at the top right corner:",
  },
  INSTALL_APP_STEP_1_CHROME: {
    id: "INSTALL_APP_STEP_1_CHROME",
    defaultMessage:
      "Chrome browser tap the menu button (three vertical dots) at the top right corner:",
  },
  INSTALL_APP_STEP_2_SAFARI: {
    id: "INSTALL_APP_STEP_2_SAFARI",
    defaultMessage: "Scroll in the share menu and select 'Add to Home Screen'.",
  },
  INSTALL_APP_STEP_2_FIREFOX: {
    id: "INSTALL_APP_STEP_2_FIREFOX",
    defaultMessage: "Tap select 'Install'",
  },
  INSTALL_APP_STEP_2_CHROME: {
    id: "INSTALL_APP_STEP_2_CHROME",
    defaultMessage: "Tap select 'Install app':",
  },
  INSTALL_APP_STEP_3_SAFARI: {
    id: "INSTALL_APP_STEP_3_SAFARI",
    defaultMessage: "Then, tap 'Add' at the top right corner.",
  },
  INSTALL_APP_STEP_3_FIREFOX: {
    id: "INSTALL_APP_STEP_3_FIREFOX",
    defaultMessage: "Confirm by tapping 'Add'.",
  },
  INSTALL_APP_STEP_3_CHROME: {
    id: "INSTALL_APP_STEP_3_CHROME",
    defaultMessage: "Then, confirm by tapping 'Add'.",
  },
  INSTALL_APP_STEP_3_SUCCESS: {
    id: "INSTALL_APP_STEP_3_SUCCESS",
    defaultMessage: "And that's it! TutoriFy★ is now on your home screen.",
  },
  APP_INSTALL: {
    id: "APP_INSTALL",
    defaultMessage: "App install",
  },
  LATER: {
    id: "LATER",
    defaultMessage: "Later",
  },
  INSTALL_APP_STEP_4: {
    id: "INSTALL_APP_STEP_4",
    defaultMessage:
      "You can see the App Installation information again by clicking on the menu icon",
  },
  DONE: {
    id: "DONE",
    defaultMessage: "Done",
  },
  UNDONE: {
    id: "UNDONE",
    defaultMessage: "Undone",
  },
  NONE: {
    id: "NONE",
    defaultMessage: "None",
  },
  NAME: {
    id: "NAME",
    defaultMessage: "Name",
  },
  TRACKIFY: {
    id: "TRACKIFY",
    defaultMessage: "Trackify",
  },
  TRACKIFY_CLASSES: {
    id: "TRACKIFY_CLASSES",
    defaultMessage: "Classes",
  },
  TRACKIFY_GRADES: {
    id: "TRACKIFY_GRADES",
    defaultMessage: "Grades",
  },
  TRACKIFY_QUARTER: {
    id: "TRACKIFY_QUARTER",
    defaultMessage: "Quarter",
  },
  TRACKIFY_HALBJAHR: {
    id: "TRACKIFY_HALBJAHR",
    defaultMessage: "Semester",
  },
  TRACKIFY_ZEUGNIS: {
    id: "TRACKIFY_ZEUGNIS",
    defaultMessage: "Certificate",
  },
  TRACKIFY_SCHRIFTLICH: {
    id: "TRACKIFY_SCHRIFTLICH",
    defaultMessage: "Written",
  },
  TRACKIFY_MUENDLICH: {
    id: "TRACKIFY_MUENDLICH",
    defaultMessage: "Oral",
  },
  TRACKIFY_AT: {
    id: "TRACKIFY_AT",
    defaultMessage: "Other work",
  },
  TRACKIFY_NOTE: {
    id: "TRACKIFY_NOTE",
    defaultMessage: "Grade",
  },
  TRACKIFY_NOTENWERT: {
    id: "TRACKIFY_NOTENWERT",
    defaultMessage: "Grade value",
  },
  TRACKIFY_SCHOOL_YEAR: {
    id: "TRACKIFY_SCHOOL_YEAR",
    defaultMessage: "School year",
  },
  TRACKIFY_CONFIG: {
    id: "TRACKIFY_CONFIG",
    defaultMessage: "Trackify settings",
  },
  TRACKIFY_KURS_TYPE: {
    id: "TRACKIFY_KURS_TYPE",
    defaultMessage: "Course type",
  },
  TRACKIFY_KLASSE_LEVEL: {
    id: "TRACKIFY_KLASSE_LEVEL",
    defaultMessage: "Class level",
  },
  TRACKIFY_OBERSTUFE: {
    id: "TRACKIFY_OBERSTUFE",
    defaultMessage: "Upper level",
  },
  TRACKIFY_GERUNDET: {
    id: "TRACKIFY_GERUNDET",
    defaultMessage: "Rounded",
  },
  TRACKIFY_E_KURS: {
    id: "TRACKIFY_E_KURS",
    defaultMessage: "E-Course",
  },
  TRACKIFY_G_KURS: {
    id: "TRACKIFY_G_KURS",
    defaultMessage: "G-Course",
  },
  TRACKIFY_IN_PROGRESS: {
    id: "TRACKIFY_IN_PROGRESS",
    defaultMessage: "in progress",
  },
  TRACKIFY_GRADED: {
    id: "TRACKIFY_GRADED",
    defaultMessage: "graded",
  },
  TRACKIFY_PRINT: {
    id: "TRACKIFY_PRINT",
    defaultMessage: "Print",
  },
  TRACKIFY_NO_VALUE: {
    id: "TRACKIFY_NO_VALUE",
    defaultMessage: "n/a",
  },
  SHOW_MORE: {
    id: "SHOW_MORE",
    defaultMessage: "Show more",
  },
  SHOW_LESS: {
    id: "SHOW_LESS",
    defaultMessage: "Show less",
  },
  TRACKIFY_INCOMPLETE: {
    id: "TRACKIFY_INCOMPLETE",
    defaultMessage: "incomplete",
  },
  TRACKIFY_AVERAGE: {
    id: "TRACKIFY_AVERAGE",
    defaultMessage: "Average",
  },
  TRACKIFY_TREND: {
    id: "TRACKIFY_TREND",
    defaultMessage: "Trend",
  },
  TRACKIFY_EXPORT_CSV: {
    id: "TRACKIFY_EXPORT_CSV",
    defaultMessage: "Export CSV",
  },
  TRACKIFY_EXPORT_EXCEL: {
    id: "TRACKIFY_EXPORT_EXCEL",
    defaultMessage: "Export Excel",
  },
  TRACKIFY_TEST_AVG: {
    id: "TRACKIFY_TEST_AVG",
    defaultMessage: "T∅",
  },
  TRACKIFY_NONE_LABEL: {
    id: "TRACKIFY_NONE_LABEL",
    defaultMessage: "General (no course type)",
  },
  TRACKIFY_GK_LABEL: {
    id: "TRACKIFY_GK_LABEL",
    defaultMessage: "GK (General course)",
  },
  TRACKIFY_LK_LABEL: {
    id: "TRACKIFY_LK_LABEL",
    defaultMessage: "LK (Advanced course)",
  },
  TRACKIFY_KLASSE: {
    id: "TRACKIFY_KLASSE",
    defaultMessage: "Class",
  },
  TRACKIFY_WEIGHT_PRESET: {
    id: "TRACKIFY_WEIGHT_PRESET",
    defaultMessage: "Weight preset",
  },
  TRACKIFY_PRESET_BERLIN: {
    id: "TRACKIFY_PRESET_BERLIN",
    defaultMessage: "Berlin Sek I",
  },
  TRACKIFY_PRESET_CUSTOM: {
    id: "TRACKIFY_PRESET_CUSTOM",
    defaultMessage: "Custom",
  },
  TRACKIFY_WEIGHT_KA_LEK: {
    id: "TRACKIFY_WEIGHT_KA_LEK",
    defaultMessage: "KA / LEK",
  },
  TRACKIFY_WEIGHT_MUENDLICH_TESTS: {
    id: "TRACKIFY_WEIGHT_MUENDLICH_TESTS",
    defaultMessage: "Oral / Tests",
  },
  TRACKIFY_WEIGHT_SCHRIFTLICH_AT: {
    id: "TRACKIFY_WEIGHT_SCHRIFTLICH_AT",
    defaultMessage: "Written / AT",
  },
  TRACKIFY_WEIGHT_OBERSTUFE_SCHRIFTLICH_AT: {
    id: "TRACKIFY_WEIGHT_OBERSTUFE_SCHRIFTLICH_AT",
    defaultMessage: "Oberstufe Written / AT",
  },
  TRACKIFY_TOOLTIP_KA: {
    id: "TRACKIFY_TOOLTIP_KA",
    defaultMessage: "Klassenarbeit (class test)",
  },
  TRACKIFY_TOOLTIP_LEK: {
    id: "TRACKIFY_TOOLTIP_LEK",
    defaultMessage: "Lernerfolgskontrolle (learning check)",
  },
  TRACKIFY_TOOLTIP_SCHRIFTLICH: {
    id: "TRACKIFY_TOOLTIP_SCHRIFTLICH",
    defaultMessage: "Written grade (KA + LEK weighted)",
  },
  TRACKIFY_TOOLTIP_MUENDLICH: {
    id: "TRACKIFY_TOOLTIP_MUENDLICH",
    defaultMessage: "Oral participation grade",
  },
  TRACKIFY_TOOLTIP_TEST: {
    id: "TRACKIFY_TOOLTIP_TEST",
    defaultMessage: "Test",
  },
  TRACKIFY_TOOLTIP_TEST_AVG: {
    id: "TRACKIFY_TOOLTIP_TEST_AVG",
    defaultMessage: "Test average",
  },
  TRACKIFY_TOOLTIP_AT: {
    id: "TRACKIFY_TOOLTIP_AT",
    defaultMessage: "Allgemeiner Teil (general part: oral + tests)",
  },
  TRACKIFY_TOOLTIP_NOTENWERT: {
    id: "TRACKIFY_TOOLTIP_NOTENWERT",
    defaultMessage: "Grade value (1 = best, 6 = worst)",
  },
  TRACKIFY_TOOLTIP_EG: {
    id: "TRACKIFY_TOOLTIP_EG",
    defaultMessage: "E = Erweiterungskurs (advanced), G = Grundkurs (basic)",
  },
  TRACKIFY_TOOLTIP_GERUNDET: {
    id: "TRACKIFY_TOOLTIP_GERUNDET",
    defaultMessage: "Rounded to one decimal",
  },
  MODULES: {
    id: "MODULES",
    defaultMessage: "Modules",
  },
  MODULE_PARTICIFY_DESC: {
    id: "MODULE_PARTICIFY_DESC",
    defaultMessage: "Track attendance and participation",
  },
  MODULE_TRACKIFY_DESC: {
    id: "MODULE_TRACKIFY_DESC",
    defaultMessage: "Manage grades and assessments",
  },
  MODULE_COMING_SOON: {
    id: "MODULE_COMING_SOON",
    defaultMessage: "Coming soon",
  },
  TRACKIFY_BETA_TITLE: {
    id: "TRACKIFY_BETA_TITLE",
    defaultMessage: "Experimental",
  },
  TRACKIFY_BETA_DESC: {
    id: "TRACKIFY_BETA_DESC",
    defaultMessage: "This module is new and under active development. Your feedback is welcome at",
  },
  TRACKIFY_CONFIG_SAVE_ERROR: {
    id: "TRACKIFY_CONFIG_SAVE_ERROR",
    defaultMessage: "Could not save settings. Please try again.",
  },
  WHATS_NEW_TITLE: {
    id: "WHATS_NEW_TITLE",
    defaultMessage: "What's new in TutoriFy",
  },
  WHATS_NEW_BODY: {
    id: "WHATS_NEW_BODY",
    defaultMessage: "Each class now has a module hub. Click on a class to see all available modules.",
  },
  WHATS_NEW_TRACKIFY: {
    id: "WHATS_NEW_TRACKIFY",
    defaultMessage: "Your students' grades, organized by assessment. Export to CSV for your school.",
  },
  WHATS_NEW_CALENDFY: {
    id: "WHATS_NEW_CALENDFY",
    defaultMessage: "Your class schedule with reminders. TutoriFy knows when you have class.",
  },
  WHATS_NEW_NOTIFY: {
    id: "WHATS_NEW_NOTIFY",
    defaultMessage: "Automated email reminders for attendance, homework, grades, and daily summaries.",
  },
  WHATS_NEW_LOGIFY: {
    id: "WHATS_NEW_LOGIFY",
    defaultMessage: "Observations with categories: academic, social, behavior. Your class logbook.",
  },
  WHATS_NEW_REPORTIFY: {
    id: "WHATS_NEW_REPORTIFY",
    defaultMessage: "Automatic reports from the data you already track. For Elternabend, for you.",
  },
  FD_HOMEWORK_TIP: {
    id: "FD_HOMEWORK_TIP",
    defaultMessage: "Tip: Had homework today? Activate the Homework checkbox above to track who completed it.",
  },
  FD_HOMEWORK_CTA: {
    id: "FD_HOMEWORK_CTA",
    defaultMessage: "Show me",
  },
  FD_OBSERVATION_TIP: {
    id: "FD_OBSERVATION_TIP",
    defaultMessage: "Want to note something about a student today? Click 'Observation' on their card to add a quick note.",
  },
  FD_OBSERVATION_CTA: {
    id: "FD_OBSERVATION_CTA",
    defaultMessage: "Got it",
  },
  FD_LOGIFY_TIP: {
    id: "FD_LOGIFY_TIP",
    defaultMessage: "Your observations are valuable! LogiFy lets you structure them with categories (academic, social, behavior) and track sentiment over time.",
  },
  FD_LOGIFY_CTA: {
    id: "FD_LOGIFY_CTA",
    defaultMessage: "Explore LogiFy",
  },
  FD_TRACKIFY_TIP: {
    id: "FD_TRACKIFY_TIP",
    defaultMessage: "Need to track formal grades? TrackiFy lets you record assessments and calculate averages automatically.",
  },
  FD_TRACKIFY_CTA: {
    id: "FD_TRACKIFY_CTA",
    defaultMessage: "Try TrackiFy",
  },
  FD_REPORTIFY_TIP: {
    id: "FD_REPORTIFY_TIP",
    defaultMessage: "You have a month of data! ReportiFy can generate PDF reports with your students' trends — great for Elternabend.",
  },
  FD_REPORTIFY_CTA: {
    id: "FD_REPORTIFY_CTA",
    defaultMessage: "Generate Report",
  },
  MODULE_REPORTIFY_DESC: {
    id: "MODULE_REPORTIFY_DESC",
    defaultMessage: "Generate PDF reports and analytics",
  },
  TRACKIFY_EMPTY_TITLE: {
    id: "TRACKIFY_EMPTY_TITLE",
    defaultMessage: "No students yet",
  },
  TRACKIFY_EMPTY_DESC: {
    id: "TRACKIFY_EMPTY_DESC",
    defaultMessage: "Add students to this class from ParticiFy first, then come back here to track their grades.",
  },
  TRACKIFY_GO_TO_PARTICIFY: {
    id: "TRACKIFY_GO_TO_PARTICIFY",
    defaultMessage: "Go to ParticiFy",
  },
  FIRST_NAME: {
    id: "FIRST_NAME",
    defaultMessage: "First name",
  },
  LAST_NAME: {
    id: "LAST_NAME",
    defaultMessage: "Last name",
  },
  JOB_TITLE: {
    id: "JOB_TITLE",
    defaultMessage: "Job title",
  },
  BIO: {
    id: "BIO",
    defaultMessage: "Bio",
  },
  CHANGE_PASSWORD: {
    id: "CHANGE_PASSWORD",
    defaultMessage: "Change password",
  },
  CURRENT_PASSWORD: {
    id: "CURRENT_PASSWORD",
    defaultMessage: "Current password",
  },
  NEW_PASSWORD: {
    id: "NEW_PASSWORD",
    defaultMessage: "New password",
  },
  UPDATE_PROFILE_SUCCESS: {
    id: "UPDATE_PROFILE_SUCCESS",
    defaultMessage: "Profile updated successfully",
  },
  UPDATE_PROFILE_ERROR: {
    id: "UPDATE_PROFILE_ERROR",
    defaultMessage: "Error updating profile, please try again.",
  },
  UPDATE_PASSWORD_SUCCESS: {
    id: "UPDATE_PASSWORD_SUCCESS",
    defaultMessage: "Password updated successfully",
  },
  UPDATE_PASSWORD_ERROR: {
    id: "UPDATE_PASSWORD_ERROR",
    defaultMessage: "Error updating password, please try again.",
  },
  CURRENT_PASSWORD_INCORRECT: {
    id: "CURRENT_PASSWORD_INCORRECT",
    defaultMessage: "Current password is incorrect",
  },
  PASSWORD_MIN_LENGTH: {
    id: "PASSWORD_MIN_LENGTH",
    defaultMessage: "Password must be at least 6 characters",
  },
  CALENDFY: {
    id: "CALENDFY",
    defaultMessage: "Calendar",
  },
  CALENDFY_EVENT: {
    id: "CALENDFY_EVENT",
    defaultMessage: "Event",
  },
  CALENDFY_NEW_EVENT: {
    id: "CALENDFY_NEW_EVENT",
    defaultMessage: "New event",
  },
  CALENDFY_EDIT_EVENT: {
    id: "CALENDFY_EDIT_EVENT",
    defaultMessage: "Edit event",
  },
  CALENDFY_DELETE_EVENT: {
    id: "CALENDFY_DELETE_EVENT",
    defaultMessage: "Delete event",
  },
  CALENDFY_WEEK: {
    id: "CALENDFY_WEEK",
    defaultMessage: "Week",
  },
  CALENDFY_DAY: {
    id: "CALENDFY_DAY",
    defaultMessage: "Day",
  },
  CALENDFY_MONTH: {
    id: "CALENDFY_MONTH",
    defaultMessage: "Month",
  },
  CALENDFY_RECURRING: {
    id: "CALENDFY_RECURRING",
    defaultMessage: "Recurring rule",
  },
  CALENDFY_WIZARD: {
    id: "CALENDFY_WIZARD",
    defaultMessage: "Schedule Wizard",
  },
  CALENDFY_CLASS: {
    id: "CALENDFY_CLASS",
    defaultMessage: "Class",
  },
  CALENDFY_EXAM: {
    id: "CALENDFY_EXAM",
    defaultMessage: "Exam",
  },
  CALENDFY_SPECIAL: {
    id: "CALENDFY_SPECIAL",
    defaultMessage: "Special",
  },
  CALENDFY_HOLIDAY: {
    id: "CALENDFY_HOLIDAY",
    defaultMessage: "Holiday",
  },
  CALENDFY_SUBSTITUTION: {
    id: "CALENDFY_SUBSTITUTION",
    defaultMessage: "Substitution",
  },
  CALENDFY_OTHER: {
    id: "CALENDFY_OTHER",
    defaultMessage: "Other",
  },
  CALENDFY_NO_EVENTS: {
    id: "CALENDFY_NO_EVENTS",
    defaultMessage: "No events on this day",
  },
  CALENDFY_EVENT_CREATED: {
    id: "CALENDFY_EVENT_CREATED",
    defaultMessage: "Event created",
  },
  CALENDFY_EVENT_UPDATED: {
    id: "CALENDFY_EVENT_UPDATED",
    defaultMessage: "Event updated",
  },
  CALENDFY_EVENT_DELETED: {
    id: "CALENDFY_EVENT_DELETED",
    defaultMessage: "Event deleted",
  },
  CALENDFY_SCHEDULE_CREATED: {
    id: "CALENDFY_SCHEDULE_CREATED",
    defaultMessage: "Schedule created!",
  },
  CALENDFY_RECURRING_ABBR: {
    id: "CALENDFY_RECURRING_ABBR",
    defaultMessage: "Rec.",
  },
  CALENDFY_RECURRING_LABEL: {
    id: "CALENDFY_RECURRING_LABEL",
    defaultMessage: "Recurring",
  },
  CALENDFY_RECURRING_EVENT: {
    id: "CALENDFY_RECURRING_EVENT",
    defaultMessage: "Recurring event",
  },
  CALENDFY_EXPERIMENTAL: {
    id: "CALENDFY_EXPERIMENTAL",
    defaultMessage: "Experimental",
  },
  CALENDFY_EXPERIMENTAL_DESC: {
    id: "CALENDFY_EXPERIMENTAL_DESC",
    defaultMessage: "This module is new and under active development. Your feedback is welcome at",
  },
  EXPERIMENTAL_BANNER_TITLE: {
    id: "EXPERIMENTAL_BANNER_TITLE",
    defaultMessage: "{moduleName} — Experimental",
  },
  EXPERIMENTAL_BANNER_DESCRIPTION: {
    id: "EXPERIMENTAL_BANNER_DESCRIPTION",
    defaultMessage: "This module is still in development. Your opinion matters! Tell us what works well, what's missing, or what bothers you — so we can improve {moduleName} for your teaching. Reach us at: {email}",
  },
  EXPERIMENTAL_BANNER_FEEDBACK: {
    id: "EXPERIMENTAL_BANNER_FEEDBACK",
    defaultMessage: "Give Feedback",
  },
  CALENDFY_TODAY: {
    id: "CALENDFY_TODAY",
    defaultMessage: "Today",
  },
  CALENDFY_FILTER_BY: {
    id: "CALENDFY_FILTER_BY",
    defaultMessage: "Filter by:",
  },
  CALENDFY_ALL_CLASSES: {
    id: "CALENDFY_ALL_CLASSES",
    defaultMessage: "All classes",
  },
  CALENDFY_RULE_BUTTON: {
    id: "CALENDFY_RULE_BUTTON",
    defaultMessage: "Recurring",
  },
  CALENDFY_ASSISTANT: {
    id: "CALENDFY_ASSISTANT",
    defaultMessage: "Wizard",
  },
  CALENDFY_EXPORT: {
    id: "CALENDFY_EXPORT",
    defaultMessage: "Export",
  },
  CALENDFY_DUPLICATE_EVENT: {
    id: "CALENDFY_DUPLICATE_EVENT",
    defaultMessage: "Duplicate event",
  },
  CALENDFY_ADJUST_DETAILS: {
    id: "CALENDFY_ADJUST_DETAILS",
    defaultMessage: "Adjust the event details.",
  },
  CALENDFY_COPY_EVENT_DESC: {
    id: "CALENDFY_COPY_EVENT_DESC",
    defaultMessage: "Create a copy of the event.",
  },
  CALENDFY_NEW_EVENT_DESC: {
    id: "CALENDFY_NEW_EVENT_DESC",
    defaultMessage: "Create a new event in your calendar.",
  },
  CALENDFY_ERROR: {
    id: "CALENDFY_ERROR",
    defaultMessage: "Something went wrong",
  },
  CALENDFY_EVENTS_DELETED: {
    id: "CALENDFY_EVENTS_DELETED",
    defaultMessage: "Event(s) deleted",
  },
  CALENDFY_ALL_SERIES_UPDATED: {
    id: "CALENDFY_ALL_SERIES_UPDATED",
    defaultMessage: "All events in series updated",
  },
  CALENDFY_RECURRING_RULE_CREATED: {
    id: "CALENDFY_RECURRING_RULE_CREATED",
    defaultMessage: "Recurring rule created",
  },
  CALENDFY_RECURRING_RULE_DESC: {
    id: "CALENDFY_RECURRING_RULE_DESC",
    defaultMessage: "Create a rule for recurring events.",
  },
  CALENDFY_DELETE_RECURRING_TITLE: {
    id: "CALENDFY_DELETE_RECURRING_TITLE",
    defaultMessage: "Delete recurring event",
  },
  CALENDFY_DELETE_RECURRING_DESC: {
    id: "CALENDFY_DELETE_RECURRING_DESC",
    defaultMessage: "This event belongs to a recurring rule. What would you like to delete?",
  },
  CALENDFY_ONLY_THIS: {
    id: "CALENDFY_ONLY_THIS",
    defaultMessage: "Only this event",
  },
  CALENDFY_THIS_AND_FUTURE: {
    id: "CALENDFY_THIS_AND_FUTURE",
    defaultMessage: "This and future events",
  },
  CALENDFY_ALL_IN_RULE: {
    id: "CALENDFY_ALL_IN_RULE",
    defaultMessage: "All events in rule",
  },
  CALENDFY_EDIT_RECURRING_TITLE: {
    id: "CALENDFY_EDIT_RECURRING_TITLE",
    defaultMessage: "Edit recurring event",
  },
  CALENDFY_EDIT_RECURRING_DESC: {
    id: "CALENDFY_EDIT_RECURRING_DESC",
    defaultMessage: "This event belongs to a series. Would you like to update only this event or all events in the series?",
  },
  CALENDFY_ALL_IN_SERIES: {
    id: "CALENDFY_ALL_IN_SERIES",
    defaultMessage: "All events in series",
  },
  CALENDFY_ALL_BLOCKED_DATE: {
    id: "CALENDFY_ALL_BLOCKED_DATE",
    defaultMessage: "Date can only be changed for this single event",
  },
  CALENDFY_EVENTS_PLURAL: {
    id: "CALENDFY_EVENTS_PLURAL",
    defaultMessage: "events",
  },
  CALENDFY_EVENT_TYPE_SECTION: {
    id: "CALENDFY_EVENT_TYPE_SECTION",
    defaultMessage: "Event type",
  },
  CALENDFY_GENERAL_INFO: {
    id: "CALENDFY_GENERAL_INFO",
    defaultMessage: "General information",
  },
  CALENDFY_CLASSROOM: {
    id: "CALENDFY_CLASSROOM",
    defaultMessage: "Class",
  },
  CALENDFY_NO_CLASS: {
    id: "CALENDFY_NO_CLASS",
    defaultMessage: "No class",
  },
  CALENDFY_SUBTITLE_LABEL: {
    id: "CALENDFY_SUBTITLE_LABEL",
    defaultMessage: "Subtitle (optional)",
  },
  CALENDFY_SUBTITLE_HELPER: {
    id: "CALENDFY_SUBTITLE_HELPER",
    defaultMessage: "Shown below the class name",
  },
  CALENDFY_DATE: {
    id: "CALENDFY_DATE",
    defaultMessage: "Date",
  },
  CALENDFY_TIME_START: {
    id: "CALENDFY_TIME_START",
    defaultMessage: "Start",
  },
  CALENDFY_TIME_END: {
    id: "CALENDFY_TIME_END",
    defaultMessage: "End",
  },
  CALENDFY_TIME_ERROR: {
    id: "CALENDFY_TIME_ERROR",
    defaultMessage: "Start time must be before end time.",
  },
  CALENDFY_PREPARATION: {
    id: "CALENDFY_PREPARATION",
    defaultMessage: "Preparation / Lesson planning",
  },
  CALENDFY_PREP_HINT: {
    id: "CALENDFY_PREP_HINT",
    defaultMessage: "Plan your lesson: topics, activities, materials, time structure...",
  },
  CALENDFY_TEMPLATES: {
    id: "CALENDFY_TEMPLATES",
    defaultMessage: "Templates",
  },
  CALENDFY_ADD_BLOCKS: {
    id: "CALENDFY_ADD_BLOCKS",
    defaultMessage: "Add building blocks",
  },
  CALENDFY_HOMEWORKS: {
    id: "CALENDFY_HOMEWORKS",
    defaultMessage: "Homeworks",
  },
  CALENDFY_EXISTING: {
    id: "CALENDFY_EXISTING",
    defaultMessage: "Existing",
  },
  CALENDFY_NEW_HOMEWORK: {
    id: "CALENDFY_NEW_HOMEWORK",
    defaultMessage: "New homework...",
  },
  CALENDFY_DAYS_OF_WEEK: {
    id: "CALENDFY_DAYS_OF_WEEK",
    defaultMessage: "Days of week",
  },
  CALENDFY_DATE_RANGE: {
    id: "CALENDFY_DATE_RANGE",
    defaultMessage: "Date range",
  },
  CALENDFY_START_DATE: {
    id: "CALENDFY_START_DATE",
    defaultMessage: "Start date",
  },
  CALENDFY_END_DATE: {
    id: "CALENDFY_END_DATE",
    defaultMessage: "End date",
  },
  CALENDFY_DATE_RANGE_ERROR: {
    id: "CALENDFY_DATE_RANGE_ERROR",
    defaultMessage: "End date must be on or after the start date.",
  },
  CALENDFY_RECURRING_PREP_HINT: {
    id: "CALENDFY_RECURRING_PREP_HINT",
    defaultMessage: "Plan your recurring class: topics, structure, materials...",
  },
  CALENDFY_RECURRING_PREP_PLACEHOLDER: {
    id: "CALENDFY_RECURRING_PREP_PLACEHOLDER",
    defaultMessage: "Enter lesson plan here...",
  },
  CALENDFY_WIZ_STEP_YEAR: {
    id: "CALENDFY_WIZ_STEP_YEAR",
    defaultMessage: "School year",
  },
  CALENDFY_WIZ_STEP_CLASSES: {
    id: "CALENDFY_WIZ_STEP_CLASSES",
    defaultMessage: "Classes",
  },
  CALENDFY_WIZ_STEP_CONFIRM: {
    id: "CALENDFY_WIZ_STEP_CONFIRM",
    defaultMessage: "Confirm",
  },
  CALENDFY_WIZ_SETUP_YEAR: {
    id: "CALENDFY_WIZ_SETUP_YEAR",
    defaultMessage: "Set up school year",
  },
  CALENDFY_WIZ_SETUP_YEAR_DESC: {
    id: "CALENDFY_WIZ_SETUP_YEAR_DESC",
    defaultMessage: "Define the period for your schedule. CalendFy will automatically generate all events.",
  },
  CALENDFY_WIZ_YEAR_START: {
    id: "CALENDFY_WIZ_YEAR_START",
    defaultMessage: "Year start",
  },
  CALENDFY_WIZ_YEAR_END: {
    id: "CALENDFY_WIZ_YEAR_END",
    defaultMessage: "Year end",
  },
  CALENDFY_WIZ_SKIP: {
    id: "CALENDFY_WIZ_SKIP",
    defaultMessage: "Skip",
  },
  CALENDFY_WIZ_NEXT: {
    id: "CALENDFY_WIZ_NEXT",
    defaultMessage: "Next →",
  },
  CALENDFY_WIZ_SETUP_CLASSES: {
    id: "CALENDFY_WIZ_SETUP_CLASSES",
    defaultMessage: "Set up weekly classes",
  },
  CALENDFY_WIZ_SETUP_CLASSES_DESC: {
    id: "CALENDFY_WIZ_SETUP_CLASSES_DESC",
    defaultMessage: "Add all your classes with weekday and time.",
  },
  CALENDFY_WIZ_ADD_CLASS: {
    id: "CALENDFY_WIZ_ADD_CLASS",
    defaultMessage: "Add new class",
  },
  CALENDFY_WIZ_COURSE: {
    id: "CALENDFY_WIZ_COURSE",
    defaultMessage: "Course",
  },
  CALENDFY_WIZ_SELECT_CLASS: {
    id: "CALENDFY_WIZ_SELECT_CLASS",
    defaultMessage: "Select class",
  },
  CALENDFY_WIZ_ADD_ENTRY: {
    id: "CALENDFY_WIZ_ADD_ENTRY",
    defaultMessage: "Add class",
  },
  CALENDFY_WIZ_BACK: {
    id: "CALENDFY_WIZ_BACK",
    defaultMessage: "← Back",
  },
  CALENDFY_WIZ_REVIEW: {
    id: "CALENDFY_WIZ_REVIEW",
    defaultMessage: "Review everything",
  },
  CALENDFY_WIZ_REVIEW_DESC: {
    id: "CALENDFY_WIZ_REVIEW_DESC",
    defaultMessage: "CalendFy will automatically generate all events for the school year.",
  },
  CALENDFY_WIZ_PERIOD: {
    id: "CALENDFY_WIZ_PERIOD",
    defaultMessage: "Period",
  },
  CALENDFY_WIZ_TEACHING_WEEKS: {
    id: "CALENDFY_WIZ_TEACHING_WEEKS",
    defaultMessage: "Teaching weeks",
  },
  CALENDFY_WIZ_WEEKS: {
    id: "CALENDFY_WIZ_WEEKS",
    defaultMessage: "weeks",
  },
  CALENDFY_WIZ_EVENTS_AUTO: {
    id: "CALENDFY_WIZ_EVENTS_AUTO",
    defaultMessage: "Events will be automatically generated",
  },
  CALENDFY_WIZ_CREATING: {
    id: "CALENDFY_WIZ_CREATING",
    defaultMessage: "Creating...",
  },
  CALENDFY_WIZ_GENERATE: {
    id: "CALENDFY_WIZ_GENERATE",
    defaultMessage: "✓ Generate schedule",
  },
  CALENDFY_PREP_PLACEHOLDER: {
    id: "CALENDFY_PREP_PLACEHOLDER",
    defaultMessage: "e.g.\n## Topic\nFractions \u2013 Introduction\n\n## Structure\n- [ ] Warm-up (10 min): Review...\n- [ ] Main (25 min): New content...\n- [ ] Practice (10 min): Exercises...",
  },
  CALENDFY_DELETE_CONFIRM_TITLE: {
    id: "CALENDFY_DELETE_CONFIRM_TITLE",
    defaultMessage: "Delete event",
  },
  CALENDFY_DELETE_CONFIRM_DESC: {
    id: "CALENDFY_DELETE_CONFIRM_DESC",
    defaultMessage: "Are you sure you want to delete this event? This action cannot be undone.",
  },
  CALENDFY_DELETE: {
    id: "CALENDFY_DELETE",
    defaultMessage: "Delete",
  },
  CALENDFY_TEMPLATE_REPLACE_CONFIRM: {
    id: "CALENDFY_TEMPLATE_REPLACE_CONFIRM",
    defaultMessage: "Replace your current preparation content with this template?",
  },
  CALENDFY_WIZ_PARTIAL_ERROR: {
    id: "CALENDFY_WIZ_PARTIAL_ERROR",
    defaultMessage: "Some rules could not be created. Created {count} of {total}.",
  },
  CALENDFY_WIZ_OVERLAP_ERROR: {
    id: "CALENDFY_WIZ_OVERLAP_ERROR",
    defaultMessage: "Time overlaps with \"{entry}\". A teacher cannot have two classes at the same time.",
  },
  CALENDFY_WIZ_RESULT_SUCCESS: {
    id: "CALENDFY_WIZ_RESULT_SUCCESS",
    defaultMessage: "Your schedule is ready!",
  },
  CALENDFY_WIZ_RESULT_PARTIAL: {
    id: "CALENDFY_WIZ_RESULT_PARTIAL",
    defaultMessage: "Schedule created with conflicts",
  },
  CALENDFY_WIZ_RESULT_BLOCKED: {
    id: "CALENDFY_WIZ_RESULT_BLOCKED",
    defaultMessage: "All time slots are already taken",
  },
  CALENDFY_WIZ_RESULT_EVENTS: {
    id: "CALENDFY_WIZ_RESULT_EVENTS",
    defaultMessage: "events created",
  },
  CALENDFY_WIZ_RESULT_SKIPPED: {
    id: "CALENDFY_WIZ_RESULT_SKIPPED",
    defaultMessage: "events skipped",
  },
  CALENDFY_WIZ_RESULT_SKIP_REASON: {
    id: "CALENDFY_WIZ_RESULT_SKIP_REASON",
    defaultMessage: "These time slots already had events. A teacher cannot be in two places at once.",
  },
  CALENDFY_WIZ_RESULT_RULE: {
    id: "CALENDFY_WIZ_RESULT_RULE",
    defaultMessage: "recurring rule created",
  },
  CALENDFY_WIZ_RESULT_RULES: {
    id: "CALENDFY_WIZ_RESULT_RULES",
    defaultMessage: "recurring rules created",
  },
  CALENDFY_WIZ_RESULT_DONE: {
    id: "CALENDFY_WIZ_RESULT_DONE",
    defaultMessage: "View my schedule",
  },
  CALENDFY_WIZ_RESULT_CLOSE: {
    id: "CALENDFY_WIZ_RESULT_CLOSE",
    defaultMessage: "Understood",
  },
  CALENDFY_HW_DELETE_ERROR: {
    id: "CALENDFY_HW_DELETE_ERROR",
    defaultMessage: "Could not delete homework",
  },
  MODULE_CALENDFY_DESC: {
    id: "MODULE_CALENDFY_DESC",
    defaultMessage: "Plan your lessons and events",
  },
  CALENDFY_QUICKSTART_TITLE: {
    id: "CALENDFY_QUICKSTART_TITLE",
    defaultMessage: "Getting Started",
  },
  CALENDFY_QUICKSTART_DISMISS: {
    id: "CALENDFY_QUICKSTART_DISMISS",
    defaultMessage: "Got it, thanks!",
  },
  CALENDFY_QS_STEP1_TITLE: {
    id: "CALENDFY_QS_STEP1_TITLE",
    defaultMessage: "Create your first event",
  },
  CALENDFY_QS_STEP1_DESC: {
    id: "CALENDFY_QS_STEP1_DESC",
    defaultMessage: "Tap \"+Event\" to add a class, exam, or special event to any date.",
  },
  CALENDFY_QS_STEP2_TITLE: {
    id: "CALENDFY_QS_STEP2_TITLE",
    defaultMessage: "Automate with rules",
  },
  CALENDFY_QS_STEP2_DESC: {
    id: "CALENDFY_QS_STEP2_DESC",
    defaultMessage: "Use \"Recurring\" to repeat events weekly — set it once, forget it.",
  },
  CALENDFY_QS_STEP3_TITLE: {
    id: "CALENDFY_QS_STEP3_TITLE",
    defaultMessage: "Plan it all at once",
  },
  CALENDFY_QS_STEP3_DESC: {
    id: "CALENDFY_QS_STEP3_DESC",
    defaultMessage: "The Schedule Wizard builds a full timetable for a class in one go.",
  },
  CALENDFY_QS_STEP4_TITLE: {
    id: "CALENDFY_QS_STEP4_TITLE",
    defaultMessage: "Filter & export",
  },
  CALENDFY_QS_STEP4_DESC: {
    id: "CALENDFY_QS_STEP4_DESC",
    defaultMessage: "Filter by class and export to iCal for Google Calendar or Outlook.",
  },
  CALENDFY_EXPORT_ICAL: {
    id: "CALENDFY_EXPORT_ICAL",
    defaultMessage: "iCal file",
  },
  CALENDFY_EXPORT_GOOGLE: {
    id: "CALENDFY_EXPORT_GOOGLE",
    defaultMessage: "Google Calendar",
  },
  CALENDFY_EXPORT_OUTLOOK: {
    id: "CALENDFY_EXPORT_OUTLOOK",
    defaultMessage: "Outlook",
  },
  CALENDFY_EXPORT_WARN_MANY: {
    id: "CALENDFY_EXPORT_WARN_MANY",
    defaultMessage: "Only the first event was opened. Use iCal download for multiple events.",
  },
  CALENDFY_CONFLICT_HEADER: {
    id: "CALENDFY_CONFLICT_HEADER",
    defaultMessage: "Time conflict \u2014 this slot is taken",
  },
  CALENDFY_CONFLICT_DESC_ONE: {
    id: "CALENDFY_CONFLICT_DESC_ONE",
    defaultMessage: "Your event overlaps with an existing one. You can still save, but consider adjusting the time.",
  },
  CALENDFY_CONFLICT_DESC_MANY: {
    id: "CALENDFY_CONFLICT_DESC_MANY",
    defaultMessage: "Your event overlaps with {count} existing events. You can still save, but consider adjusting the time.",
  },
  CALENDFY_CONFLICT_EVENT_FALLBACK: {
    id: "CALENDFY_CONFLICT_EVENT_FALLBACK",
    defaultMessage: "Event",
  },
  CALENDFY_RTE_UNDO: {
    id: "CALENDFY_RTE_UNDO",
    defaultMessage: "Undo",
  },
  CALENDFY_RTE_REDO: {
    id: "CALENDFY_RTE_REDO",
    defaultMessage: "Redo",
  },
  CALENDFY_RTE_HEADING: {
    id: "CALENDFY_RTE_HEADING",
    defaultMessage: "Heading",
  },
  CALENDFY_RTE_BOLD: {
    id: "CALENDFY_RTE_BOLD",
    defaultMessage: "Bold",
  },
  CALENDFY_RTE_ITALIC: {
    id: "CALENDFY_RTE_ITALIC",
    defaultMessage: "Italic",
  },
  CALENDFY_RTE_UNDERLINE: {
    id: "CALENDFY_RTE_UNDERLINE",
    defaultMessage: "Underline",
  },
  CALENDFY_RTE_HIGHLIGHT: {
    id: "CALENDFY_RTE_HIGHLIGHT",
    defaultMessage: "Highlight",
  },
  CALENDFY_RTE_BULLET_LIST: {
    id: "CALENDFY_RTE_BULLET_LIST",
    defaultMessage: "Bullet list",
  },
  CALENDFY_RTE_NUMBERED_LIST: {
    id: "CALENDFY_RTE_NUMBERED_LIST",
    defaultMessage: "Numbered list",
  },
  CALENDFY_RTE_TASK_LIST: {
    id: "CALENDFY_RTE_TASK_LIST",
    defaultMessage: "Task list",
  },
  CALENDFY_RTE_BLOCKQUOTE: {
    id: "CALENDFY_RTE_BLOCKQUOTE",
    defaultMessage: "Blockquote",
  },
  CALENDFY_RTE_CODE_BLOCK: {
    id: "CALENDFY_RTE_CODE_BLOCK",
    defaultMessage: "Code block",
  },
  CALENDFY_RTE_DIVIDER: {
    id: "CALENDFY_RTE_DIVIDER",
    defaultMessage: "Divider",
  },
  CALENDFY_TYPE_ABBREV_CLASS: {
    id: "CALENDFY_TYPE_ABBREV_CLASS",
    defaultMessage: "CLS",
  },
  CALENDFY_TYPE_ABBREV_EXAM: {
    id: "CALENDFY_TYPE_ABBREV_EXAM",
    defaultMessage: "EXM",
  },
  CALENDFY_TYPE_ABBREV_SPECIAL: {
    id: "CALENDFY_TYPE_ABBREV_SPECIAL",
    defaultMessage: "SPC",
  },
  CALENDFY_TYPE_ABBREV_HOLIDAY: {
    id: "CALENDFY_TYPE_ABBREV_HOLIDAY",
    defaultMessage: "HOL",
  },
  CALENDFY_TYPE_ABBREV_SUBSTITUTION: {
    id: "CALENDFY_TYPE_ABBREV_SUBSTITUTION",
    defaultMessage: "SUB",
  },
  CALENDFY_TYPE_ABBREV_OTHER: {
    id: "CALENDFY_TYPE_ABBREV_OTHER",
    defaultMessage: "OTH",
  },
  CALENDFY_EMPTY_WEEK: {
    id: "CALENDFY_EMPTY_WEEK",
    defaultMessage: "No events this week",
  },
  CALENDFY_EMPTY_MONTH: {
    id: "CALENDFY_EMPTY_MONTH",
    defaultMessage: "No events this month",
  },
  CALENDFY_EMPTY_HINT: {
    id: "CALENDFY_EMPTY_HINT",
    defaultMessage: "Tap \"+Event\" or use the Schedule Wizard to get started.",
  },
  CALENDFY_NAV_PREV: {
    id: "CALENDFY_NAV_PREV",
    defaultMessage: "Previous",
  },
  CALENDFY_NAV_NEXT: {
    id: "CALENDFY_NAV_NEXT",
    defaultMessage: "Next",
  },
  CALENDFY_ACTION_EDIT: {
    id: "CALENDFY_ACTION_EDIT",
    defaultMessage: "Edit event",
  },
  CALENDFY_ACTION_DELETE: {
    id: "CALENDFY_ACTION_DELETE",
    defaultMessage: "Delete event",
  },
  CALENDFY_ACTION_DUPLICATE: {
    id: "CALENDFY_ACTION_DUPLICATE",
    defaultMessage: "Duplicate event",
  },
  CALENDFY_LOADING: {
    id: "CALENDFY_LOADING",
    defaultMessage: "Loading\u2026",
  },
  NOTIFY_TITLE: {
    id: "NOTIFY_TITLE",
    defaultMessage: "Notifications",
  },
  NOTIFY_MARK_ALL_READ: {
    id: "NOTIFY_MARK_ALL_READ",
    defaultMessage: "Mark all read",
  },
  NOTIFY_EMPTY: {
    id: "NOTIFY_EMPTY",
    defaultMessage: "No notifications yet",
  },
  NOTIFY_SETTINGS_TITLE: {
    id: "NOTIFY_SETTINGS_TITLE",
    defaultMessage: "Notification settings",
  },
  NOTIFY_EMAIL_SECTION: {
    id: "NOTIFY_EMAIL_SECTION",
    defaultMessage: "Email notifications",
  },
  NOTIFY_EMAIL_ENABLED: {
    id: "NOTIFY_EMAIL_ENABLED",
    defaultMessage: "Email notifications",
  },
  NOTIFY_DAILY_SUMMARY: {
    id: "NOTIFY_DAILY_SUMMARY",
    defaultMessage: "Daily summary",
  },
  NOTIFY_SUMMARY_TIME: {
    id: "NOTIFY_SUMMARY_TIME",
    defaultMessage: "Summary time",
  },
  NOTIFY_ALERTS_SECTION: {
    id: "NOTIFY_ALERTS_SECTION",
    defaultMessage: "Alert preferences",
  },
  NOTIFY_CLASS_REMINDER: {
    id: "NOTIFY_CLASS_REMINDER",
    defaultMessage: "Class reminders",
  },
  NOTIFY_REMINDER_MINUTES: {
    id: "NOTIFY_REMINDER_MINUTES",
    defaultMessage: "Remind before (min)",
  },
  NOTIFY_ATTENDANCE_MISSING: {
    id: "NOTIFY_ATTENDANCE_MISSING",
    defaultMessage: "Missing attendance",
  },
  NOTIFY_HOMEWORK_PENDING: {
    id: "NOTIFY_HOMEWORK_PENDING",
    defaultMessage: "Pending homework",
  },
  NOTIFY_GRADE_PENDING: {
    id: "NOTIFY_GRADE_PENDING",
    defaultMessage: "Pending grades",
  },
  NOTIFY_SETTINGS_SAVED: {
    id: "NOTIFY_SETTINGS_SAVED",
    defaultMessage: "Settings saved",
  },
  NOTIFY_SETTINGS_ERROR: {
    id: "NOTIFY_SETTINGS_ERROR",
    defaultMessage: "Could not save settings",
  },
  NOTIFY_SAVING: {
    id: "NOTIFY_SAVING",
    defaultMessage: "Saving...",
  },
  NOTIFY_CLASS_REMINDER_BODY: {
    id: "NOTIFY_CLASS_REMINDER_BODY",
    defaultMessage: "Your class starts soon",
  },
  NOTIFY_ATTENDANCE_MISSING_BODY: {
    id: "NOTIFY_ATTENDANCE_MISSING_BODY",
    defaultMessage: "Attendance has not been recorded",
  },
  NOTIFY_HOMEWORK_PENDING_BODY: {
    id: "NOTIFY_HOMEWORK_PENDING_BODY",
    defaultMessage: "Homework is due",
  },
  NOTIFY_GRADE_PENDING_BODY: {
    id: "NOTIFY_GRADE_PENDING_BODY",
    defaultMessage: "Grades are pending",
  },
  NOTIFY_NEW_ONE: {
    id: "NOTIFY_NEW_ONE",
    defaultMessage: "New notification",
  },
  NOTIFY_NEW_MANY: {
    id: "NOTIFY_NEW_MANY",
    defaultMessage: "new notifications",
  },
  NOTIFY_DELETE: {
    id: "NOTIFY_DELETE",
    defaultMessage: "Delete",
  },
  NOTIFY_TIME_NOW: {
    id: "NOTIFY_TIME_NOW",
    defaultMessage: "now",
  },
  NOTIFY_TIME_MINUTES: {
    id: "NOTIFY_TIME_MINUTES",
    defaultMessage: "m",
  },
  NOTIFY_TIME_HOURS: {
    id: "NOTIFY_TIME_HOURS",
    defaultMessage: "h",
  },
  NOTIFY_TIME_DAYS: {
    id: "NOTIFY_TIME_DAYS",
    defaultMessage: "d",
  },
  NOTIFY_UNREAD_BADGE: {
    id: "NOTIFY_UNREAD_BADGE",
    defaultMessage: "unread notifications",
  },
  NOTIFY_MINUTES_UNIT: {
    id: "NOTIFY_MINUTES_UNIT",
    defaultMessage: "min",
  },
  MODULE_NOTIFY_DESC: {
    id: "MODULE_NOTIFY_DESC",
    defaultMessage: "Stay on top of your teaching tasks",
  },

  // ── LogiFy ──
  LOGIFY: { id: "LOGIFY", defaultMessage: "Observations" },
  LOGIFY_QUICK_BUTTON: { id: "LOGIFY_QUICK_BUTTON", defaultMessage: "Observation" },
  LOGIFY_TIMELINE: { id: "LOGIFY_TIMELINE", defaultMessage: "Timeline" },
  LOGIFY_BY_STUDENT: { id: "LOGIFY_BY_STUDENT", defaultMessage: "By Student" },
  LOGIFY_CATEGORY_ACADEMIC: { id: "LOGIFY_CATEGORY_ACADEMIC", defaultMessage: "Academic" },
  LOGIFY_CATEGORY_SOCIAL: { id: "LOGIFY_CATEGORY_SOCIAL", defaultMessage: "Social" },
  LOGIFY_CATEGORY_BEHAVIOR: { id: "LOGIFY_CATEGORY_BEHAVIOR", defaultMessage: "Behavior" },
  LOGIFY_CATEGORY_COMMUNICATION: { id: "LOGIFY_CATEGORY_COMMUNICATION", defaultMessage: "Communication" },
  LOGIFY_CATEGORY_PROGRESS: { id: "LOGIFY_CATEGORY_PROGRESS", defaultMessage: "Progress" },
  LOGIFY_SENTIMENT_POSITIVE: { id: "LOGIFY_SENTIMENT_POSITIVE", defaultMessage: "Positive" },
  LOGIFY_SENTIMENT_NEUTRAL: { id: "LOGIFY_SENTIMENT_NEUTRAL", defaultMessage: "Neutral" },
  LOGIFY_SENTIMENT_ATTENTION: { id: "LOGIFY_SENTIMENT_ATTENTION", defaultMessage: "Attention" },
  LOGIFY_FORM_CLASS: { id: "LOGIFY_FORM_CLASS", defaultMessage: "Class" },
  LOGIFY_FORM_STUDENT: { id: "LOGIFY_FORM_STUDENT", defaultMessage: "Student" },
  LOGIFY_FORM_CATEGORY: { id: "LOGIFY_FORM_CATEGORY", defaultMessage: "Category" },
  LOGIFY_FORM_SENTIMENT: { id: "LOGIFY_FORM_SENTIMENT", defaultMessage: "Assessment" },
  LOGIFY_FORM_TEXT: { id: "LOGIFY_FORM_TEXT", defaultMessage: "Observation" },
  LOGIFY_FORM_DATE: { id: "LOGIFY_FORM_DATE", defaultMessage: "Date" },
  LOGIFY_FORM_LINK_EVENT: { id: "LOGIFY_FORM_LINK_EVENT", defaultMessage: "Link event (optional)" },
  LOGIFY_FORM_NO_EVENT: { id: "LOGIFY_FORM_NO_EVENT", defaultMessage: "No event" },
  LOGIFY_STATS_TOTAL: { id: "LOGIFY_STATS_TOTAL", defaultMessage: "Observations" },
  LOGIFY_STATS_POSITIVE: { id: "LOGIFY_STATS_POSITIVE", defaultMessage: "Positive" },
  LOGIFY_STATS_NEUTRAL: { id: "LOGIFY_STATS_NEUTRAL", defaultMessage: "Neutral" },
  LOGIFY_STATS_ATTENTION: { id: "LOGIFY_STATS_ATTENTION", defaultMessage: "Attention" },
  LOGIFY_CREATED: { id: "LOGIFY_CREATED", defaultMessage: "Observation saved" },
  LOGIFY_UPDATED: { id: "LOGIFY_UPDATED", defaultMessage: "Observation updated" },
  LOGIFY_DELETED: { id: "LOGIFY_DELETED", defaultMessage: "Observation deleted" },
  LOGIFY_NO_OBSERVATIONS: { id: "LOGIFY_NO_OBSERVATIONS", defaultMessage: "No observations yet" },
  LOGIFY_DELETE_CONFIRM: { id: "LOGIFY_DELETE_CONFIRM", defaultMessage: "Delete observation?" },
  LOGIFY_DELETE_MESSAGE: { id: "LOGIFY_DELETE_MESSAGE", defaultMessage: "This action cannot be undone." },
  LOGIFY_EMPTY_HINT: { id: "LOGIFY_EMPTY_HINT", defaultMessage: "Tap + to record your first observation" },
  LOGIFY_SELECT_CLASS: { id: "LOGIFY_SELECT_CLASS", defaultMessage: "Select a class to begin" },
  LOGIFY_SELECT_STUDENT: { id: "LOGIFY_SELECT_STUDENT", defaultMessage: "Select a student" },
  LOGIFY_SELECT_STUDENT_HINT: { id: "LOGIFY_SELECT_STUDENT_HINT", defaultMessage: "Pick a student from the list to see their observations" },
  LOGIFY_NO_STUDENTS: { id: "LOGIFY_NO_STUDENTS", defaultMessage: "No students in this class" },
  LOGIFY_NO_STUDENTS_HINT: { id: "LOGIFY_NO_STUDENTS_HINT", defaultMessage: "Add students in ParticiFy to start recording observations" },
  LOGIFY_GO_PARTICIFY: { id: "LOGIFY_GO_PARTICIFY", defaultMessage: "Go to ParticiFy" },
  LOGIFY_FILTERS: { id: "LOGIFY_FILTERS", defaultMessage: "Filters" },

  // ── ReportiFy ──
  REPORTIFY: {
    id: "REPORTIFY",
    defaultMessage: "Reports",
  },
  REPORTIFY_SUBTITLE: {
    id: "REPORTIFY_SUBTITLE",
    defaultMessage: "Reports & Analytics",
  },
  REPORTIFY_TAB_STUDENT: {
    id: "REPORTIFY_TAB_STUDENT",
    defaultMessage: "Student",
  },
  REPORTIFY_TAB_CLASS: {
    id: "REPORTIFY_TAB_CLASS",
    defaultMessage: "Class",
  },
  REPORTIFY_TAB_COMPARISON: {
    id: "REPORTIFY_TAB_COMPARISON",
    defaultMessage: "Comparison",
  },
  REPORTIFY_TAB_SAVED: {
    id: "REPORTIFY_TAB_SAVED",
    defaultMessage: "Saved",
  },
  REPORTIFY_CLASS: {
    id: "REPORTIFY_CLASS",
    defaultMessage: "Class",
  },
  REPORTIFY_STUDENT: {
    id: "REPORTIFY_STUDENT",
    defaultMessage: "Student",
  },
  REPORTIFY_SELECT_STUDENT: {
    id: "REPORTIFY_SELECT_STUDENT",
    defaultMessage: "Select student...",
  },
  REPORTIFY_COMPARE_STUDENTS: {
    id: "REPORTIFY_COMPARE_STUDENTS",
    defaultMessage: "Students (2\u20134)",
  },
  REPORTIFY_START: {
    id: "REPORTIFY_START",
    defaultMessage: "From",
  },
  REPORTIFY_END: {
    id: "REPORTIFY_END",
    defaultMessage: "To",
  },
  REPORTIFY_SAVE: {
    id: "REPORTIFY_SAVE",
    defaultMessage: "Save Report",
  },
  REPORTIFY_SAVE_PDF: {
    id: "REPORTIFY_SAVE_PDF",
    defaultMessage: "Save & generate PDF",
  },
  REPORTIFY_SAVE_WITH_PDF: {
    id: "REPORTIFY_SAVE_WITH_PDF",
    defaultMessage: "Save + PDF",
  },
  REPORTIFY_SELECT_CLASS_HINT: {
    id: "REPORTIFY_SELECT_CLASS_HINT",
    defaultMessage: "Select a class to begin",
  },
  REPORTIFY_SELECT_STUDENT_HINT: {
    id: "REPORTIFY_SELECT_STUDENT_HINT",
    defaultMessage: "Select a student to preview the report",
  },
  REPORTIFY_SELECT_COMPARISON_HINT: {
    id: "REPORTIFY_SELECT_COMPARISON_HINT",
    defaultMessage: "Select 2\u20134 students to compare",
  },
  REPORTIFY_LOADING: {
    id: "REPORTIFY_LOADING",
    defaultMessage: "Loading\u2026",
  },
  REPORTIFY_REPORT_SAVED: {
    id: "REPORTIFY_REPORT_SAVED",
    defaultMessage: "Report saved",
  },
  REPORTIFY_REPORT_EXISTS: {
    id: "REPORTIFY_REPORT_EXISTS",
    defaultMessage: "This report already exists",
  },
  REPORTIFY_SAVE_ERROR: {
    id: "REPORTIFY_SAVE_ERROR",
    defaultMessage: "Error saving report",
  },
  REPORTIFY_PDF_DOWNLOADED: {
    id: "REPORTIFY_PDF_DOWNLOADED",
    defaultMessage: "PDF downloaded",
  },
  REPORTIFY_PDF_DOWNLOAD_FAILED: {
    id: "REPORTIFY_PDF_DOWNLOAD_FAILED",
    defaultMessage: "PDF download failed",
  },
  REPORTIFY_REPORT_DELETED: {
    id: "REPORTIFY_REPORT_DELETED",
    defaultMessage: "Report deleted",
  },
  REPORTIFY_PDF_GENERATED: {
    id: "REPORTIFY_PDF_GENERATED",
    defaultMessage: "PDF generated",
  },
  REPORTIFY_MAX_STUDENTS: {
    id: "REPORTIFY_MAX_STUDENTS",
    defaultMessage: "Maximum 4 students for comparison",
  },
  REPORTIFY_DOWNLOAD_PDF: {
    id: "REPORTIFY_DOWNLOAD_PDF",
    defaultMessage: "Download PDF",
  },
  REPORTIFY_BACK: {
    id: "REPORTIFY_BACK",
    defaultMessage: "Back",
  },
  REPORTIFY_OPEN_PDF: {
    id: "REPORTIFY_OPEN_PDF",
    defaultMessage: "Open PDF",
  },
  REPORTIFY_GENERATE_PDF: {
    id: "REPORTIFY_GENERATE_PDF",
    defaultMessage: "Generate PDF",
  },
  REPORTIFY_DELETE: {
    id: "REPORTIFY_DELETE",
    defaultMessage: "Delete",
  },
  REPORTIFY_VIEW: {
    id: "REPORTIFY_VIEW",
    defaultMessage: "View",
  },
  REPORTIFY_NOT_FOUND: {
    id: "REPORTIFY_NOT_FOUND",
    defaultMessage: "Report not found",
  },
  REPORTIFY_NO_DATA: {
    id: "REPORTIFY_NO_DATA",
    defaultMessage: "No data available",
  },
  REPORTIFY_NO_SAVED: {
    id: "REPORTIFY_NO_SAVED",
    defaultMessage: "No saved reports",
  },
  REPORTIFY_NO_SAVED_HINT: {
    id: "REPORTIFY_NO_SAVED_HINT",
    defaultMessage: "Select a class and student in the Student tab, then click Save to keep a snapshot here",
  },
  REPORTIFY_NOT_FOUND_HINT: {
    id: "REPORTIFY_NOT_FOUND_HINT",
    defaultMessage: "This report may have been deleted",
  },
  REPORTIFY_NO_STUDENTS: {
    id: "REPORTIFY_NO_STUDENTS",
    defaultMessage: "No students in this class",
  },
  REPORTIFY_NO_STUDENTS_HINT: {
    id: "REPORTIFY_NO_STUDENTS_HINT",
    defaultMessage: "Add students to this class via ParticiFy",
  },
  REPORTIFY_ATTENDANCE: {
    id: "REPORTIFY_ATTENDANCE",
    defaultMessage: "Attendance",
  },
  REPORTIFY_PARTICIPATION: {
    id: "REPORTIFY_PARTICIPATION",
    defaultMessage: "Participation",
  },
  REPORTIFY_HOMEWORK: {
    id: "REPORTIFY_HOMEWORK",
    defaultMessage: "Homework",
  },
  REPORTIFY_GRADE: {
    id: "REPORTIFY_GRADE",
    defaultMessage: "Grade",
  },
  REPORTIFY_RADAR: {
    id: "REPORTIFY_RADAR",
    defaultMessage: "Radar",
  },
  REPORTIFY_HEATMAP: {
    id: "REPORTIFY_HEATMAP",
    defaultMessage: "Attendance Heatmap",
  },
  REPORTIFY_MONTHLY_EVOLUTION: {
    id: "REPORTIFY_MONTHLY_EVOLUTION",
    defaultMessage: "Monthly Evolution",
  },
  REPORTIFY_STREAK: {
    id: "REPORTIFY_STREAK",
    defaultMessage: "Streak",
  },
  REPORTIFY_STREAK_CURRENT: {
    id: "REPORTIFY_STREAK_CURRENT",
    defaultMessage: "Current",
  },
  REPORTIFY_STREAK_BEST: {
    id: "REPORTIFY_STREAK_BEST",
    defaultMessage: "Best",
  },
  REPORTIFY_BADGES: {
    id: "REPORTIFY_BADGES",
    defaultMessage: "Badges",
  },
  REPORTIFY_CLASS_COMPARISON: {
    id: "REPORTIFY_CLASS_COMPARISON",
    defaultMessage: "Comparison with Class",
  },
  REPORTIFY_OBSERVATIONS: {
    id: "REPORTIFY_OBSERVATIONS",
    defaultMessage: "Observations",
  },
  REPORTIFY_RISK_DISTRIBUTION: {
    id: "REPORTIFY_RISK_DISTRIBUTION",
    defaultMessage: "Risk Distribution",
  },
  REPORTIFY_RISK_STABLE: {
    id: "REPORTIFY_RISK_STABLE",
    defaultMessage: "Stable",
  },
  REPORTIFY_RISK_WARNING: {
    id: "REPORTIFY_RISK_WARNING",
    defaultMessage: "Warning",
  },
  REPORTIFY_RISK_DANGER: {
    id: "REPORTIFY_RISK_DANGER",
    defaultMessage: "At Risk",
  },
  REPORTIFY_DISTRIBUTION: {
    id: "REPORTIFY_DISTRIBUTION",
    defaultMessage: "Distribution",
  },
  REPORTIFY_ATT_90: {
    id: "REPORTIFY_ATT_90",
    defaultMessage: "Att. 90%+",
  },
  REPORTIFY_PART_4: {
    id: "REPORTIFY_PART_4",
    defaultMessage: "Part. 4+",
  },
  REPORTIFY_HW_80: {
    id: "REPORTIFY_HW_80",
    defaultMessage: "HW 80%+",
  },
  REPORTIFY_GRADE_10: {
    id: "REPORTIFY_GRADE_10",
    defaultMessage: "Grade 10+",
  },
  REPORTIFY_STUDENTS: {
    id: "REPORTIFY_STUDENTS",
    defaultMessage: "Students",
  },
  REPORTIFY_COMPARISON: {
    id: "REPORTIFY_COMPARISON",
    defaultMessage: "Comparison",
  },
  REPORTIFY_INSIGHTS: {
    id: "REPORTIFY_INSIGHTS",
    defaultMessage: "Insights",
  },
  REPORTIFY_INSIGHT_LEADER_METRICS: {
    id: "REPORTIFY_INSIGHT_LEADER_METRICS",
    defaultMessage: "{name} leads in {count} of 4 metrics this period",
  },
  REPORTIFY_INSIGHT_LOW_ATTENDANCE: {
    id: "REPORTIFY_INSIGHT_LOW_ATTENDANCE",
    defaultMessage: "{name} has the lowest attendance ({value}%)",
  },
  REPORTIFY_INSIGHT_LOW_HOMEWORK: {
    id: "REPORTIFY_INSIGHT_LOW_HOMEWORK",
    defaultMessage: "{name} has less than 50% homework completed ({value}%)",
  },
  REPORTIFY_INSIGHT_LOW_GRADE: {
    id: "REPORTIFY_INSIGHT_LOW_GRADE",
    defaultMessage: "{name} has the lowest grade ({value}/{max})",
  },
  REPORTIFY_INSIGHT_HIGH_PARTICIPATION: {
    id: "REPORTIFY_INSIGHT_HIGH_PARTICIPATION",
    defaultMessage: "{name} stands out in participation ({value})",
  },
  REPORTIFY_INSIGHT_TOP_GRADE: {
    id: "REPORTIFY_INSIGHT_TOP_GRADE",
    defaultMessage: "{name} has the top grade ({value}/{max})",
  },
  REPORTIFY_INSIGHT_HOMEWORK_GAP: {
    id: "REPORTIFY_INSIGHT_HOMEWORK_GAP",
    defaultMessage: "{gap}pp homework gap between {highName} ({highValue}%) and {lowName} ({lowValue}%)",
  },
  REPORTIFY_INSIGHT_AT_RISK_STUDENT: {
    id: "REPORTIFY_INSIGHT_AT_RISK_STUDENT",
    defaultMessage: "{name} shows combined risk: low attendance ({attendance}%) and low participation ({participation})",
  },
  REPORTIFY_YOU: {
    id: "REPORTIFY_YOU",
    defaultMessage: "You",
  },
  REPORTIFY_CLASS_LABEL: {
    id: "REPORTIFY_CLASS_LABEL",
    defaultMessage: "Class",
  },
  REPORTIFY_TYPE_STUDENT: {
    id: "REPORTIFY_TYPE_STUDENT",
    defaultMessage: "Student",
  },
  REPORTIFY_TYPE_CLASS: {
    id: "REPORTIFY_TYPE_CLASS",
    defaultMessage: "Class",
  },
  REPORTIFY_TYPE_COMPARISON: {
    id: "REPORTIFY_TYPE_COMPARISON",
    defaultMessage: "Comparison",
  },
  REPORTIFY_NAME: {
    id: "REPORTIFY_NAME",
    defaultMessage: "Name",
  },
  REPORTIFY_RISK: {
    id: "REPORTIFY_RISK",
    defaultMessage: "Risk",
  },
  REPORTIFY_DAY_MO: { id: "REPORTIFY_DAY_MO", defaultMessage: "Mo" },
  REPORTIFY_DAY_TU: { id: "REPORTIFY_DAY_TU", defaultMessage: "Tu" },
  REPORTIFY_DAY_WE: { id: "REPORTIFY_DAY_WE", defaultMessage: "We" },
  REPORTIFY_DAY_TH: { id: "REPORTIFY_DAY_TH", defaultMessage: "Th" },
  REPORTIFY_DAY_FR: { id: "REPORTIFY_DAY_FR", defaultMessage: "Fr" },
  REPORTIFY_DAY_SA: { id: "REPORTIFY_DAY_SA", defaultMessage: "Sa" },
  REPORTIFY_DAY_SU: { id: "REPORTIFY_DAY_SU", defaultMessage: "Su" },
  REPORTIFY_TITLE_REPORT: {
    id: "REPORTIFY_TITLE_REPORT",
    defaultMessage: "Report",
  },
  REPORTIFY_TITLE_CLASS: {
    id: "REPORTIFY_TITLE_CLASS",
    defaultMessage: "Class",
  },
  REPORTIFY_TITLE_COMPARISON: {
    id: "REPORTIFY_TITLE_COMPARISON",
    defaultMessage: "Comparison",
  },
  REPORTIFY_MON_JAN: { id: "REPORTIFY_MON_JAN", defaultMessage: "Jan" },
  REPORTIFY_MON_FEB: { id: "REPORTIFY_MON_FEB", defaultMessage: "Feb" },
  REPORTIFY_MON_MAR: { id: "REPORTIFY_MON_MAR", defaultMessage: "Mar" },
  REPORTIFY_MON_APR: { id: "REPORTIFY_MON_APR", defaultMessage: "Apr" },
  REPORTIFY_MON_MAY: { id: "REPORTIFY_MON_MAY", defaultMessage: "May" },
  REPORTIFY_MON_JUN: { id: "REPORTIFY_MON_JUN", defaultMessage: "Jun" },
  REPORTIFY_MON_JUL: { id: "REPORTIFY_MON_JUL", defaultMessage: "Jul" },
  REPORTIFY_MON_AUG: { id: "REPORTIFY_MON_AUG", defaultMessage: "Aug" },
  REPORTIFY_MON_SEP: { id: "REPORTIFY_MON_SEP", defaultMessage: "Sep" },
  REPORTIFY_MON_OCT: { id: "REPORTIFY_MON_OCT", defaultMessage: "Oct" },
  REPORTIFY_MON_NOV: { id: "REPORTIFY_MON_NOV", defaultMessage: "Nov" },
  REPORTIFY_MON_DEC: { id: "REPORTIFY_MON_DEC", defaultMessage: "Dec" },
  REPORTIFY_PRESENT: { id: "REPORTIFY_PRESENT", defaultMessage: "present" },
  REPORTIFY_ABSENT: { id: "REPORTIFY_ABSENT", defaultMessage: "absent" },
  REPORTIFY_LESS: { id: "REPORTIFY_LESS", defaultMessage: "Less" },
  REPORTIFY_MORE: { id: "REPORTIFY_MORE", defaultMessage: "More" },
  REPORTIFY_BADGE_STREAK_7: { id: "REPORTIFY_BADGE_STREAK_7", defaultMessage: "7-Day Streak" },
  REPORTIFY_BADGE_STREAK_14: { id: "REPORTIFY_BADGE_STREAK_14", defaultMessage: "14-Day Streak" },
  REPORTIFY_BADGE_PERFECT_ATTENDANCE_MONTH: { id: "REPORTIFY_BADGE_PERFECT_ATTENDANCE_MONTH", defaultMessage: "Perfect Attendance (Month)" },
  REPORTIFY_BADGE_ALL_HOMEWORK_MONTH: { id: "REPORTIFY_BADGE_ALL_HOMEWORK_MONTH", defaultMessage: "All HW in a Month" },
  REPORTIFY_BADGE_BEST_PARTICIPATION: { id: "REPORTIFY_BADGE_BEST_PARTICIPATION", defaultMessage: "Best Participation in Class" },
  REPORTIFY_BADGE_IMPROVED_PARTICIPATION: { id: "REPORTIFY_BADGE_IMPROVED_PARTICIPATION", defaultMessage: "Participation Improved" },
  REPORTIFY_ANNUAL_TREND: { id: "REPORTIFY_ANNUAL_TREND", defaultMessage: "Annual Trend" },
  REPORTIFY_SEPTEMBER_DIP: { id: "REPORTIFY_SEPTEMBER_DIP", defaultMessage: "October is historically your most challenging month" },
  REPORTIFY_HOMEWORK_BY_TYPE: { id: "REPORTIFY_HOMEWORK_BY_TYPE", defaultMessage: "Homework by Task" },
  REPORTIFY_ENGAGEMENT_DIMENSION: { id: "REPORTIFY_ENGAGEMENT_DIMENSION", defaultMessage: "Engagement" },
  REPORTIFY_PRESENCE_DIMENSION: { id: "REPORTIFY_PRESENCE_DIMENSION", defaultMessage: "Presence" },
  REPORTIFY_CORRELATION_HIGH: { id: "REPORTIFY_CORRELATION_HIGH", defaultMessage: "High correlation participation↔homework" },
  REPORTIFY_CORRELATION_HIGH_INSIGHT: { id: "REPORTIFY_CORRELATION_HIGH_INSIGHT", defaultMessage: "Students who participate more also complete more homework. To improve homework completion, focus on increasing class engagement." },
  REPORTIFY_CORRELATION_MODERATE: { id: "REPORTIFY_CORRELATION_MODERATE", defaultMessage: "Moderate correlation" },
  REPORTIFY_CORRELATION_MODERATE_INSIGHT: { id: "REPORTIFY_CORRELATION_MODERATE_INSIGHT", defaultMessage: "There is some relationship between participation and homework completion, but it is not decisive. Other factors may play a bigger role." },
  REPORTIFY_RISK_STABLE_PROFILE: { id: "REPORTIFY_RISK_STABLE_PROFILE", defaultMessage: "Stable performance" },
  REPORTIFY_RISK_PRESENT_NOT_ENGAGED: { id: "REPORTIFY_RISK_PRESENT_NOT_ENGAGED", defaultMessage: "Present but not engaged" },
  REPORTIFY_RISK_ENGAGED_NOT_PRESENT: { id: "REPORTIFY_RISK_ENGAGED_NOT_PRESENT", defaultMessage: "Engaged but often absent" },
  REPORTIFY_RISK_AT_RISK_PROFILE: { id: "REPORTIFY_RISK_AT_RISK_PROFILE", defaultMessage: "Student needs attention" },
  REPORTIFY_CONSISTENCY_TOOLTIP: { id: "REPORTIFY_CONSISTENCY_TOOLTIP", defaultMessage: "This student has high variation in participation — some days very active, others very passive" },
  REPORTIFY_CONSISTENCY_CONSISTENT: { id: "REPORTIFY_CONSISTENCY_CONSISTENT", defaultMessage: "Very consistent" },
  REPORTIFY_CONSISTENCY_VARIABLE: { id: "REPORTIFY_CONSISTENCY_VARIABLE", defaultMessage: "Variable" },
  REPORTIFY_CONSISTENCY_VERY_VARIABLE: { id: "REPORTIFY_CONSISTENCY_VERY_VARIABLE", defaultMessage: "Very variable" },
  REPORTIFY_RATING_DISTRIBUTION: { id: "REPORTIFY_RATING_DISTRIBUTION", defaultMessage: "Rating Distribution" },
  REPORTIFY_PROFILE_ENGAGED: { id: "REPORTIFY_PROFILE_ENGAGED", defaultMessage: "Engaged class" },
  REPORTIFY_PROFILE_MIXED: { id: "REPORTIFY_PROFILE_MIXED", defaultMessage: "Mixed class" },
  REPORTIFY_PROFILE_CHALLENGING: { id: "REPORTIFY_PROFILE_CHALLENGING", defaultMessage: "Challenging class" },
  REPORTIFY_BANNER_TITLE: { id: "REPORTIFY_BANNER_TITLE", defaultMessage: "Report incomplete" },
  REPORTIFY_BANNER_NO_ATTENDANCE: { id: "REPORTIFY_BANNER_NO_ATTENDANCE", defaultMessage: "No attendance data for this period" },
  REPORTIFY_BANNER_LOW_ATTENDANCE: { id: "REPORTIFY_BANNER_LOW_ATTENDANCE", defaultMessage: "Limited attendance data (less than 5 entries)" },
  REPORTIFY_BANNER_NO_HOMEWORK: { id: "REPORTIFY_BANNER_NO_HOMEWORK", defaultMessage: "No homework data for this period" },
  REPORTIFY_BANNER_NO_GRADE: { id: "REPORTIFY_BANNER_NO_GRADE", defaultMessage: "No grade data — add grades in TrackiFy to complete this report" },
  REPORTIFY_BANNER_NO_HEATMAP: { id: "REPORTIFY_BANNER_NO_HEATMAP", defaultMessage: "No attendance history for heatmap" },
  REPORTIFY_BANNER_NO_STUDENTS: { id: "REPORTIFY_BANNER_NO_STUDENTS", defaultMessage: "No students found in this class" },
  REPORTIFY_BANNER_COMPLETE_TITLE: { id: "REPORTIFY_BANNER_COMPLETE_TITLE", defaultMessage: "Your report could be more complete" },
  REPORTIFY_BANNER_COMPLETE_SUBTITLE: { id: "REPORTIFY_BANNER_COMPLETE_SUBTITLE", defaultMessage: "Add data from other modules for richer insights" },
  REPORTIFY_BANNER_PARTICIFY: { id: "REPORTIFY_BANNER_PARTICIFY", defaultMessage: "Attendance & participation" },
  REPORTIFY_BANNER_TRACKIFY: { id: "REPORTIFY_BANNER_TRACKIFY", defaultMessage: "Grades" },
  REPORTIFY_BANNER_LOGIFY: { id: "REPORTIFY_BANNER_LOGIFY", defaultMessage: "Observations" },
  REPORTIFY_BANNER_CALENDFY: { id: "REPORTIFY_BANNER_CALENDFY", defaultMessage: "Calendar events" },
  REPORTIFY_BANNER_ACTIVE: { id: "REPORTIFY_BANNER_ACTIVE", defaultMessage: "Active" },
  REPORTIFY_BANNER_MISSING: { id: "REPORTIFY_BANNER_MISSING", defaultMessage: "No data yet" },
  REPORTIFY_BANNER_GO: { id: "REPORTIFY_BANNER_GO", defaultMessage: "Go to" },
  REPORTIFY_RADAR_NO_GRADE: { id: "REPORTIFY_RADAR_NO_GRADE", defaultMessage: "Grade axis is empty — no grade data available" },
  PARTICIFY_HW_NAMING_NUDGE: { id: "PARTICIFY_HW_NAMING_NUDGE", defaultMessage: "Tip: Name your homework tasks for better insights in ReportiFy" },
};

export default ENGLISH_TRANSLATIONS;
